var hs = globalThis && globalThis.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, a = t.length, s; n < a; n++)
      (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
};
function vs(e) {
  return e;
}
function W(e, t, r, n, a, s, o, c, l) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return function() {
        return t(e.apply(this, arguments));
      };
    case 3:
      return function() {
        return r(t(e.apply(this, arguments)));
      };
    case 4:
      return function() {
        return n(r(t(e.apply(this, arguments))));
      };
    case 5:
      return function() {
        return a(n(r(t(e.apply(this, arguments)))));
      };
    case 6:
      return function() {
        return s(a(n(r(t(e.apply(this, arguments))))));
      };
    case 7:
      return function() {
        return o(s(a(n(r(t(e.apply(this, arguments)))))));
      };
    case 8:
      return function() {
        return c(o(s(a(n(r(t(e.apply(this, arguments))))))));
      };
    case 9:
      return function() {
        return l(c(o(s(a(n(r(t(e.apply(this, arguments)))))))));
      };
  }
}
function m(e, t, r, n, a, s, o, c, l) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return t(e);
    case 3:
      return r(t(e));
    case 4:
      return n(r(t(e)));
    case 5:
      return a(n(r(t(e))));
    case 6:
      return s(a(n(r(t(e)))));
    case 7:
      return o(s(a(n(r(t(e))))));
    case 8:
      return c(o(s(a(n(r(t(e)))))));
    case 9:
      return l(c(o(s(a(n(r(t(e))))))));
    default: {
      for (var u = arguments[0], h = 1; h < arguments.length; h++)
        u = arguments[h](u);
      return u;
    }
  }
}
var ys = function(e, t) {
  var r = typeof e == "number" ? function(n) {
    return n.length >= e;
  } : e;
  return function() {
    var n = Array.from(arguments);
    return r(arguments) ? t.apply(this, n) : function(a) {
      return t.apply(void 0, hs([a], n, !1));
    };
  };
}, ms = function(e) {
  return {
    equals: function(t, r) {
      return t === r || e(t, r);
    }
  };
}, gs = function(e) {
  return ms(function(t, r) {
    for (var n in e)
      if (!e[n].equals(t[n], r[n]))
        return !1;
    return !0;
  });
};
globalThis && globalThis.__spreadArray;
var Pn = function(e) {
  return e._tag === "Some";
}, Ln = { _tag: "None" }, Vn = function(e) {
  return { _tag: "Some", value: e };
}, _s = function(e) {
  return e._tag === "Left";
}, bs = function(e) {
  return e._tag === "Right";
}, Ts = function(e) {
  return { _tag: "Left", left: e };
}, $s = function(e) {
  return { _tag: "Right", right: e };
}, As = function(e) {
  return [e];
}, Ss = [], ws = Object.prototype.hasOwnProperty, xs = function(e) {
  return function(t) {
    return function(r) {
      return r.reduce(function(n, a) {
        return e.concat(n, a);
      }, t);
    };
  };
}, Es = function(e) {
  return {
    concat: function() {
      return e;
    }
  };
}, Os = function(e) {
  return {
    concat: function(t, r) {
      var n = {};
      for (var a in e)
        ws.call(e, a) && (n[a] = e[a].concat(t[a], r[a]));
      return n;
    }
  };
}, Bt = function() {
  return { concat: vs };
}, js = function() {
  return { concat: function(e, t) {
    return t;
  } };
}, ks = xs, Cs = Es(void 0), Ur = globalThis && globalThis.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, a = t.length, s; n < a; n++)
      (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}, Rs = Ss, Is = function(e, t) {
  return e < 0 || e >= t.length;
}, Ns = function(e) {
  return function(t) {
    return Ur(Ur([], t, !0), [e], !1);
  };
}, Ps = Ns, Ls = As, F = {
  equals: function(e, t) {
    return e === t;
  }
}, Vs = {
  concat: function(e, t) {
    return e + t;
  }
}, Ms = "", ur = {
  concat: Vs.concat,
  empty: Ms
};
F.equals;
var Mn = function(e) {
  return e.trim();
}, Zn = function(e) {
  return e.length === 0;
}, Ye = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Dn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Zs() {
  this.__data__ = [], this.size = 0;
}
var Ds = Zs;
function Us(e, t) {
  return e === t || e !== e && t !== t;
}
var lr = Us, qs = lr;
function Hs(e, t) {
  for (var r = e.length; r--; )
    if (qs(e[r][0], t))
      return r;
  return -1;
}
var _t = Hs, Bs = _t, Gs = Array.prototype, zs = Gs.splice;
function Ks(e) {
  var t = this.__data__, r = Bs(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : zs.call(t, r, 1), --this.size, !0;
}
var Fs = Ks, Qs = _t;
function Ws(e) {
  var t = this.__data__, r = Qs(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var Js = Ws, Ys = _t;
function Xs(e) {
  return Ys(this.__data__, e) > -1;
}
var ei = Xs, ti = _t;
function ri(e, t) {
  var r = this.__data__, n = ti(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var ni = ri, ai = Ds, si = Fs, ii = Js, oi = ei, ci = ni;
function be(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
be.prototype.clear = ai;
be.prototype.delete = si;
be.prototype.get = ii;
be.prototype.has = oi;
be.prototype.set = ci;
var bt = be, ui = bt;
function li() {
  this.__data__ = new ui(), this.size = 0;
}
var di = li;
function fi(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var pi = fi;
function hi(e) {
  return this.__data__.get(e);
}
var vi = hi;
function yi(e) {
  return this.__data__.has(e);
}
var mi = yi, gi = typeof Ye == "object" && Ye && Ye.Object === Object && Ye, Un = gi, _i = Un, bi = typeof self == "object" && self && self.Object === Object && self, Ti = _i || bi || Function("return this")(), G = Ti, $i = G, Ai = $i.Symbol, Tt = Ai, qr = Tt, qn = Object.prototype, Si = qn.hasOwnProperty, wi = qn.toString, xe = qr ? qr.toStringTag : void 0;
function xi(e) {
  var t = Si.call(e, xe), r = e[xe];
  try {
    e[xe] = void 0;
    var n = !0;
  } catch {
  }
  var a = wi.call(e);
  return n && (t ? e[xe] = r : delete e[xe]), a;
}
var Ei = xi, Oi = Object.prototype, ji = Oi.toString;
function ki(e) {
  return ji.call(e);
}
var Ci = ki, Hr = Tt, Ri = Ei, Ii = Ci, Ni = "[object Null]", Pi = "[object Undefined]", Br = Hr ? Hr.toStringTag : void 0;
function Li(e) {
  return e == null ? e === void 0 ? Pi : Ni : Br && Br in Object(e) ? Ri(e) : Ii(e);
}
var $t = Li;
function Vi(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Ue = Vi, Mi = $t, Zi = Ue, Di = "[object AsyncFunction]", Ui = "[object Function]", qi = "[object GeneratorFunction]", Hi = "[object Proxy]";
function Bi(e) {
  if (!Zi(e))
    return !1;
  var t = Mi(e);
  return t == Ui || t == qi || t == Di || t == Hi;
}
var Hn = Bi, Gi = G, zi = Gi["__core-js_shared__"], Ki = zi, Gt = Ki, Gr = function() {
  var e = /[^.]+$/.exec(Gt && Gt.keys && Gt.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Fi(e) {
  return !!Gr && Gr in e;
}
var Qi = Fi, Wi = Function.prototype, Ji = Wi.toString;
function Yi(e) {
  if (e != null) {
    try {
      return Ji.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Bn = Yi, Xi = Hn, eo = Qi, to = Ue, ro = Bn, no = /[\\^$.*+?()[\]{}|]/g, ao = /^\[object .+?Constructor\]$/, so = Function.prototype, io = Object.prototype, oo = so.toString, co = io.hasOwnProperty, uo = RegExp(
  "^" + oo.call(co).replace(no, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function lo(e) {
  if (!to(e) || eo(e))
    return !1;
  var t = Xi(e) ? uo : ao;
  return t.test(ro(e));
}
var fo = lo;
function po(e, t) {
  return e == null ? void 0 : e[t];
}
var ho = po, vo = fo, yo = ho;
function mo(e, t) {
  var r = yo(e, t);
  return vo(r) ? r : void 0;
}
var ue = mo, go = ue, _o = G, bo = go(_o, "Map"), dr = bo, To = ue, $o = To(Object, "create"), At = $o, zr = At;
function Ao() {
  this.__data__ = zr ? zr(null) : {}, this.size = 0;
}
var So = Ao;
function wo(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var xo = wo, Eo = At, Oo = "__lodash_hash_undefined__", jo = Object.prototype, ko = jo.hasOwnProperty;
function Co(e) {
  var t = this.__data__;
  if (Eo) {
    var r = t[e];
    return r === Oo ? void 0 : r;
  }
  return ko.call(t, e) ? t[e] : void 0;
}
var Ro = Co, Io = At, No = Object.prototype, Po = No.hasOwnProperty;
function Lo(e) {
  var t = this.__data__;
  return Io ? t[e] !== void 0 : Po.call(t, e);
}
var Vo = Lo, Mo = At, Zo = "__lodash_hash_undefined__";
function Do(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Mo && t === void 0 ? Zo : t, this;
}
var Uo = Do, qo = So, Ho = xo, Bo = Ro, Go = Vo, zo = Uo;
function Te(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Te.prototype.clear = qo;
Te.prototype.delete = Ho;
Te.prototype.get = Bo;
Te.prototype.has = Go;
Te.prototype.set = zo;
var Ko = Te, Kr = Ko, Fo = bt, Qo = dr;
function Wo() {
  this.size = 0, this.__data__ = {
    hash: new Kr(),
    map: new (Qo || Fo)(),
    string: new Kr()
  };
}
var Jo = Wo;
function Yo(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Xo = Yo, ec = Xo;
function tc(e, t) {
  var r = e.__data__;
  return ec(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var St = tc, rc = St;
function nc(e) {
  var t = rc(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var ac = nc, sc = St;
function ic(e) {
  return sc(this, e).get(e);
}
var oc = ic, cc = St;
function uc(e) {
  return cc(this, e).has(e);
}
var lc = uc, dc = St;
function fc(e, t) {
  var r = dc(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var pc = fc, hc = Jo, vc = ac, yc = oc, mc = lc, gc = pc;
function $e(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
$e.prototype.clear = hc;
$e.prototype.delete = vc;
$e.prototype.get = yc;
$e.prototype.has = mc;
$e.prototype.set = gc;
var Gn = $e, _c = bt, bc = dr, Tc = Gn, $c = 200;
function Ac(e, t) {
  var r = this.__data__;
  if (r instanceof _c) {
    var n = r.__data__;
    if (!bc || n.length < $c - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Tc(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var Sc = Ac, wc = bt, xc = di, Ec = pi, Oc = vi, jc = mi, kc = Sc;
function Ae(e) {
  var t = this.__data__ = new wc(e);
  this.size = t.size;
}
Ae.prototype.clear = xc;
Ae.prototype.delete = Ec;
Ae.prototype.get = Oc;
Ae.prototype.has = jc;
Ae.prototype.set = kc;
var zn = Ae;
function Cc(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var Rc = Cc, Ic = ue, Nc = function() {
  try {
    var e = Ic(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Pc = Nc, Fr = Pc;
function Lc(e, t, r) {
  t == "__proto__" && Fr ? Fr(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var Kn = Lc, Vc = Kn, Mc = lr, Zc = Object.prototype, Dc = Zc.hasOwnProperty;
function Uc(e, t, r) {
  var n = e[t];
  (!(Dc.call(e, t) && Mc(n, r)) || r === void 0 && !(t in e)) && Vc(e, t, r);
}
var Fn = Uc, qc = Fn, Hc = Kn;
function Bc(e, t, r, n) {
  var a = !r;
  r || (r = {});
  for (var s = -1, o = t.length; ++s < o; ) {
    var c = t[s], l = n ? n(r[c], e[c], c, r, e) : void 0;
    l === void 0 && (l = e[c]), a ? Hc(r, c, l) : qc(r, c, l);
  }
  return r;
}
var wt = Bc;
function Gc(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var zc = Gc;
function Kc(e) {
  return e != null && typeof e == "object";
}
var Se = Kc, Fc = $t, Qc = Se, Wc = "[object Arguments]";
function Jc(e) {
  return Qc(e) && Fc(e) == Wc;
}
var Yc = Jc, Qr = Yc, Xc = Se, Qn = Object.prototype, eu = Qn.hasOwnProperty, tu = Qn.propertyIsEnumerable, ru = Qr(function() {
  return arguments;
}()) ? Qr : function(e) {
  return Xc(e) && eu.call(e, "callee") && !tu.call(e, "callee");
}, nu = ru, au = Array.isArray, xt = au, rt = { exports: {} };
function su() {
  return !1;
}
var iu = su;
rt.exports;
(function(e, t) {
  var r = G, n = iu, a = t && !t.nodeType && t, s = a && !0 && e && !e.nodeType && e, o = s && s.exports === a, c = o ? r.Buffer : void 0, l = c ? c.isBuffer : void 0, u = l || n;
  e.exports = u;
})(rt, rt.exports);
var fr = rt.exports, ou = 9007199254740991, cu = /^(?:0|[1-9]\d*)$/;
function uu(e, t) {
  var r = typeof e;
  return t = t ?? ou, !!t && (r == "number" || r != "symbol" && cu.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var lu = uu, du = 9007199254740991;
function fu(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= du;
}
var Wn = fu, pu = $t, hu = Wn, vu = Se, yu = "[object Arguments]", mu = "[object Array]", gu = "[object Boolean]", _u = "[object Date]", bu = "[object Error]", Tu = "[object Function]", $u = "[object Map]", Au = "[object Number]", Su = "[object Object]", wu = "[object RegExp]", xu = "[object Set]", Eu = "[object String]", Ou = "[object WeakMap]", ju = "[object ArrayBuffer]", ku = "[object DataView]", Cu = "[object Float32Array]", Ru = "[object Float64Array]", Iu = "[object Int8Array]", Nu = "[object Int16Array]", Pu = "[object Int32Array]", Lu = "[object Uint8Array]", Vu = "[object Uint8ClampedArray]", Mu = "[object Uint16Array]", Zu = "[object Uint32Array]", w = {};
w[Cu] = w[Ru] = w[Iu] = w[Nu] = w[Pu] = w[Lu] = w[Vu] = w[Mu] = w[Zu] = !0;
w[yu] = w[mu] = w[ju] = w[gu] = w[ku] = w[_u] = w[bu] = w[Tu] = w[$u] = w[Au] = w[Su] = w[wu] = w[xu] = w[Eu] = w[Ou] = !1;
function Du(e) {
  return vu(e) && hu(e.length) && !!w[pu(e)];
}
var Uu = Du;
function qu(e) {
  return function(t) {
    return e(t);
  };
}
var pr = qu, nt = { exports: {} };
nt.exports;
(function(e, t) {
  var r = Un, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, o = s && r.process, c = function() {
    try {
      var l = a && a.require && a.require("util").types;
      return l || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = c;
})(nt, nt.exports);
var hr = nt.exports, Hu = Uu, Bu = pr, Wr = hr, Jr = Wr && Wr.isTypedArray, Gu = Jr ? Bu(Jr) : Hu, Jn = Gu, zu = zc, Ku = nu, Fu = xt, Qu = fr, Wu = lu, Ju = Jn, Yu = Object.prototype, Xu = Yu.hasOwnProperty;
function el(e, t) {
  var r = Fu(e), n = !r && Ku(e), a = !r && !n && Qu(e), s = !r && !n && !a && Ju(e), o = r || n || a || s, c = o ? zu(e.length, String) : [], l = c.length;
  for (var u in e)
    (t || Xu.call(e, u)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    Wu(u, l))) && c.push(u);
  return c;
}
var Yn = el, tl = Object.prototype;
function rl(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || tl;
  return e === r;
}
var vr = rl;
function nl(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var Xn = nl, al = Xn, sl = al(Object.keys, Object), il = sl, ol = vr, cl = il, ul = Object.prototype, ll = ul.hasOwnProperty;
function dl(e) {
  if (!ol(e))
    return cl(e);
  var t = [];
  for (var r in Object(e))
    ll.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var fl = dl, pl = Hn, hl = Wn;
function vl(e) {
  return e != null && hl(e.length) && !pl(e);
}
var ea = vl, yl = Yn, ml = fl, gl = ea;
function _l(e) {
  return gl(e) ? yl(e) : ml(e);
}
var yr = _l, bl = wt, Tl = yr;
function $l(e, t) {
  return e && bl(t, Tl(t), e);
}
var Al = $l;
function Sl(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var wl = Sl, xl = Ue, El = vr, Ol = wl, jl = Object.prototype, kl = jl.hasOwnProperty;
function Cl(e) {
  if (!xl(e))
    return Ol(e);
  var t = El(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !kl.call(e, n)) || r.push(n);
  return r;
}
var Rl = Cl, Il = Yn, Nl = Rl, Pl = ea;
function Ll(e) {
  return Pl(e) ? Il(e, !0) : Nl(e);
}
var mr = Ll, Vl = wt, Ml = mr;
function Zl(e, t) {
  return e && Vl(t, Ml(t), e);
}
var Dl = Zl, at = { exports: {} };
at.exports;
(function(e, t) {
  var r = G, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, o = s ? r.Buffer : void 0, c = o ? o.allocUnsafe : void 0;
  function l(u, h) {
    if (h)
      return u.slice();
    var T = u.length, A = c ? c(T) : new u.constructor(T);
    return u.copy(A), A;
  }
  e.exports = l;
})(at, at.exports);
var Ul = at.exports;
function ql(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var Hl = ql;
function Bl(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, s = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (s[a++] = o);
  }
  return s;
}
var Gl = Bl;
function zl() {
  return [];
}
var ta = zl, Kl = Gl, Fl = ta, Ql = Object.prototype, Wl = Ql.propertyIsEnumerable, Yr = Object.getOwnPropertySymbols, Jl = Yr ? function(e) {
  return e == null ? [] : (e = Object(e), Kl(Yr(e), function(t) {
    return Wl.call(e, t);
  }));
} : Fl, gr = Jl, Yl = wt, Xl = gr;
function ed(e, t) {
  return Yl(e, Xl(e), t);
}
var td = ed;
function rd(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var ra = rd, nd = Xn, ad = nd(Object.getPrototypeOf, Object), na = ad, sd = ra, id = na, od = gr, cd = ta, ud = Object.getOwnPropertySymbols, ld = ud ? function(e) {
  for (var t = []; e; )
    sd(t, od(e)), e = id(e);
  return t;
} : cd, aa = ld, dd = wt, fd = aa;
function pd(e, t) {
  return dd(e, fd(e), t);
}
var hd = pd, vd = ra, yd = xt;
function md(e, t, r) {
  var n = t(e);
  return yd(e) ? n : vd(n, r(e));
}
var sa = md, gd = sa, _d = gr, bd = yr;
function Td(e) {
  return gd(e, bd, _d);
}
var ia = Td, $d = sa, Ad = aa, Sd = mr;
function wd(e) {
  return $d(e, Sd, Ad);
}
var xd = wd, Ed = ue, Od = G, jd = Ed(Od, "DataView"), kd = jd, Cd = ue, Rd = G, Id = Cd(Rd, "Promise"), Nd = Id, Pd = ue, Ld = G, Vd = Pd(Ld, "Set"), Md = Vd, Zd = ue, Dd = G, Ud = Zd(Dd, "WeakMap"), qd = Ud, Wt = kd, Jt = dr, Yt = Nd, Xt = Md, er = qd, oa = $t, we = Bn, Xr = "[object Map]", Hd = "[object Object]", en = "[object Promise]", tn = "[object Set]", rn = "[object WeakMap]", nn = "[object DataView]", Bd = we(Wt), Gd = we(Jt), zd = we(Yt), Kd = we(Xt), Fd = we(er), ae = oa;
(Wt && ae(new Wt(new ArrayBuffer(1))) != nn || Jt && ae(new Jt()) != Xr || Yt && ae(Yt.resolve()) != en || Xt && ae(new Xt()) != tn || er && ae(new er()) != rn) && (ae = function(e) {
  var t = oa(e), r = t == Hd ? e.constructor : void 0, n = r ? we(r) : "";
  if (n)
    switch (n) {
      case Bd:
        return nn;
      case Gd:
        return Xr;
      case zd:
        return en;
      case Kd:
        return tn;
      case Fd:
        return rn;
    }
  return t;
});
var Et = ae, Qd = Object.prototype, Wd = Qd.hasOwnProperty;
function Jd(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && Wd.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var Yd = Jd, Xd = G, ef = Xd.Uint8Array, ca = ef, an = ca;
function tf(e) {
  var t = new e.constructor(e.byteLength);
  return new an(t).set(new an(e)), t;
}
var _r = tf, rf = _r;
function nf(e, t) {
  var r = t ? rf(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var af = nf, sf = /\w*$/;
function of(e) {
  var t = new e.constructor(e.source, sf.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var cf = of, sn = Tt, on = sn ? sn.prototype : void 0, cn = on ? on.valueOf : void 0;
function uf(e) {
  return cn ? Object(cn.call(e)) : {};
}
var lf = uf, df = _r;
function ff(e, t) {
  var r = t ? df(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var pf = ff, hf = _r, vf = af, yf = cf, mf = lf, gf = pf, _f = "[object Boolean]", bf = "[object Date]", Tf = "[object Map]", $f = "[object Number]", Af = "[object RegExp]", Sf = "[object Set]", wf = "[object String]", xf = "[object Symbol]", Ef = "[object ArrayBuffer]", Of = "[object DataView]", jf = "[object Float32Array]", kf = "[object Float64Array]", Cf = "[object Int8Array]", Rf = "[object Int16Array]", If = "[object Int32Array]", Nf = "[object Uint8Array]", Pf = "[object Uint8ClampedArray]", Lf = "[object Uint16Array]", Vf = "[object Uint32Array]";
function Mf(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case Ef:
      return hf(e);
    case _f:
    case bf:
      return new n(+e);
    case Of:
      return vf(e, r);
    case jf:
    case kf:
    case Cf:
    case Rf:
    case If:
    case Nf:
    case Pf:
    case Lf:
    case Vf:
      return gf(e, r);
    case Tf:
      return new n();
    case $f:
    case wf:
      return new n(e);
    case Af:
      return yf(e);
    case Sf:
      return new n();
    case xf:
      return mf(e);
  }
}
var Zf = Mf, Df = Ue, un = Object.create, Uf = function() {
  function e() {
  }
  return function(t) {
    if (!Df(t))
      return {};
    if (un)
      return un(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}(), qf = Uf, Hf = qf, Bf = na, Gf = vr;
function zf(e) {
  return typeof e.constructor == "function" && !Gf(e) ? Hf(Bf(e)) : {};
}
var Kf = zf, Ff = Et, Qf = Se, Wf = "[object Map]";
function Jf(e) {
  return Qf(e) && Ff(e) == Wf;
}
var Yf = Jf, Xf = Yf, ep = pr, ln = hr, dn = ln && ln.isMap, tp = dn ? ep(dn) : Xf, rp = tp, np = Et, ap = Se, sp = "[object Set]";
function ip(e) {
  return ap(e) && np(e) == sp;
}
var op = ip, cp = op, up = pr, fn = hr, pn = fn && fn.isSet, lp = pn ? up(pn) : cp, dp = lp, fp = zn, pp = Rc, hp = Fn, vp = Al, yp = Dl, mp = Ul, gp = Hl, _p = td, bp = hd, Tp = ia, $p = xd, Ap = Et, Sp = Yd, wp = Zf, xp = Kf, Ep = xt, Op = fr, jp = rp, kp = Ue, Cp = dp, Rp = yr, Ip = mr, Np = 1, Pp = 2, Lp = 4, ua = "[object Arguments]", Vp = "[object Array]", Mp = "[object Boolean]", Zp = "[object Date]", Dp = "[object Error]", la = "[object Function]", Up = "[object GeneratorFunction]", qp = "[object Map]", Hp = "[object Number]", da = "[object Object]", Bp = "[object RegExp]", Gp = "[object Set]", zp = "[object String]", Kp = "[object Symbol]", Fp = "[object WeakMap]", Qp = "[object ArrayBuffer]", Wp = "[object DataView]", Jp = "[object Float32Array]", Yp = "[object Float64Array]", Xp = "[object Int8Array]", eh = "[object Int16Array]", th = "[object Int32Array]", rh = "[object Uint8Array]", nh = "[object Uint8ClampedArray]", ah = "[object Uint16Array]", sh = "[object Uint32Array]", S = {};
S[ua] = S[Vp] = S[Qp] = S[Wp] = S[Mp] = S[Zp] = S[Jp] = S[Yp] = S[Xp] = S[eh] = S[th] = S[qp] = S[Hp] = S[da] = S[Bp] = S[Gp] = S[zp] = S[Kp] = S[rh] = S[nh] = S[ah] = S[sh] = !0;
S[Dp] = S[la] = S[Fp] = !1;
function et(e, t, r, n, a, s) {
  var o, c = t & Np, l = t & Pp, u = t & Lp;
  if (r && (o = a ? r(e, n, a, s) : r(e)), o !== void 0)
    return o;
  if (!kp(e))
    return e;
  var h = Ep(e);
  if (h) {
    if (o = Sp(e), !c)
      return gp(e, o);
  } else {
    var T = Ap(e), A = T == la || T == Up;
    if (Op(e))
      return mp(e, c);
    if (T == da || T == ua || A && !a) {
      if (o = l || A ? {} : xp(e), !c)
        return l ? bp(e, yp(o, e)) : _p(e, vp(o, e));
    } else {
      if (!S[T])
        return a ? e : {};
      o = wp(e, T, c);
    }
  }
  s || (s = new fp());
  var C = s.get(e);
  if (C)
    return C;
  s.set(e, o), Cp(e) ? e.forEach(function(k) {
    o.add(et(k, t, r, k, e, s));
  }) : jp(e) && e.forEach(function(k, N) {
    o.set(N, et(k, t, r, N, e, s));
  });
  var L = u ? l ? $p : Tp : l ? Ip : Rp, V = h ? void 0 : L(e);
  return pp(V || e, function(k, N) {
    V && (N = k, k = e[N]), hp(o, N, et(k, t, r, N, e, s));
  }), o;
}
var ih = et, oh = ih, ch = 1, uh = 4;
function lh(e) {
  return oh(e, ch | uh);
}
var dh = lh;
const fh = /* @__PURE__ */ Dn(dh);
var $;
(function(e) {
  e.assertEqual = (a) => a;
  function t(a) {
  }
  e.assertIs = t;
  function r(a) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (a) => {
    const s = {};
    for (const o of a)
      s[o] = o;
    return s;
  }, e.getValidEnumValues = (a) => {
    const s = e.objectKeys(a).filter((c) => typeof a[a[c]] != "number"), o = {};
    for (const c of s)
      o[c] = a[c];
    return e.objectValues(o);
  }, e.objectValues = (a) => e.objectKeys(a).map(function(s) {
    return a[s];
  }), e.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const s = [];
    for (const o in a)
      Object.prototype.hasOwnProperty.call(a, o) && s.push(o);
    return s;
  }, e.find = (a, s) => {
    for (const o of a)
      if (s(o))
        return o;
  }, e.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && isFinite(a) && Math.floor(a) === a;
  function n(a, s = " | ") {
    return a.map((o) => typeof o == "string" ? `'${o}'` : o).join(s);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (a, s) => typeof s == "bigint" ? s.toString() : s;
})($ || ($ = {}));
var tr;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(tr || (tr = {}));
const f = $.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Q = (e) => {
  switch (typeof e) {
    case "undefined":
      return f.undefined;
    case "string":
      return f.string;
    case "number":
      return isNaN(e) ? f.nan : f.number;
    case "boolean":
      return f.boolean;
    case "function":
      return f.function;
    case "bigint":
      return f.bigint;
    case "symbol":
      return f.symbol;
    case "object":
      return Array.isArray(e) ? f.array : e === null ? f.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? f.promise : typeof Map < "u" && e instanceof Map ? f.map : typeof Set < "u" && e instanceof Set ? f.set : typeof Date < "u" && e instanceof Date ? f.date : f.object;
    default:
      return f.unknown;
  }
}, d = $.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), ph = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
class Z extends Error {
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  get errors() {
    return this.issues;
  }
  format(t) {
    const r = t || function(s) {
      return s.message;
    }, n = { _errors: [] }, a = (s) => {
      for (const o of s.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(a);
        else if (o.code === "invalid_return_type")
          a(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          a(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let c = n, l = 0;
          for (; l < o.path.length; ) {
            const u = o.path[l];
            l === o.path.length - 1 ? (c[u] = c[u] || { _errors: [] }, c[u]._errors.push(r(o))) : c[u] = c[u] || { _errors: [] }, c = c[u], l++;
          }
        }
    };
    return a(this), n;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, $.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(t(a))) : n.push(t(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
Z.create = (e) => new Z(e);
const Oe = (e, t) => {
  let r;
  switch (e.code) {
    case d.invalid_type:
      e.received === f.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case d.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, $.jsonStringifyReplacer)}`;
      break;
    case d.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${$.joinValues(e.keys, ", ")}`;
      break;
    case d.invalid_union:
      r = "Invalid input";
      break;
    case d.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${$.joinValues(e.options)}`;
      break;
    case d.invalid_enum_value:
      r = `Invalid enum value. Expected ${$.joinValues(e.options)}, received '${e.received}'`;
      break;
    case d.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case d.invalid_return_type:
      r = "Invalid function return type";
      break;
    case d.invalid_date:
      r = "Invalid date";
      break;
    case d.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : $.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case d.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case d.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case d.custom:
      r = "Invalid input";
      break;
    case d.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case d.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case d.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, $.assertNever(e);
  }
  return { message: r };
};
let fa = Oe;
function hh(e) {
  fa = e;
}
function st() {
  return fa;
}
const it = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: a } = e, s = [...r, ...a.path || []], o = {
    ...a,
    path: s
  };
  let c = "";
  const l = n.filter((u) => !!u).slice().reverse();
  for (const u of l)
    c = u(o, { data: t, defaultError: c }).message;
  return {
    ...a,
    path: s,
    message: a.message || c
  };
}, vh = [];
function p(e, t) {
  const r = it({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      e.schemaErrorMap,
      st(),
      Oe
      // then global default map
    ].filter((n) => !!n)
  });
  e.common.issues.push(r);
}
class R {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return g;
      a.status === "dirty" && t.dirty(), n.push(a.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const a of r)
      n.push({
        key: await a.key,
        value: await a.value
      });
    return R.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const a of r) {
      const { key: s, value: o } = a;
      if (s.status === "aborted" || o.status === "aborted")
        return g;
      s.status === "dirty" && t.dirty(), o.status === "dirty" && t.dirty(), s.value !== "__proto__" && (typeof o.value < "u" || a.alwaysSet) && (n[s.value] = o.value);
    }
    return { status: t.value, value: n };
  }
}
const g = Object.freeze({
  status: "aborted"
}), pa = (e) => ({ status: "dirty", value: e }), P = (e) => ({ status: "valid", value: e }), rr = (e) => e.status === "aborted", nr = (e) => e.status === "dirty", je = (e) => e.status === "valid", ot = (e) => typeof Promise < "u" && e instanceof Promise;
var v;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(v || (v = {}));
class q {
  constructor(t, r, n, a) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const hn = (e, t) => {
  if (je(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new Z(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function _(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: a } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: a } : { errorMap: (o, c) => o.code !== "invalid_type" ? { message: c.defaultError } : typeof c.data > "u" ? { message: n ?? c.defaultError } : { message: r ?? c.defaultError }, description: a };
}
class b {
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return Q(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: Q(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new R(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: Q(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (ot(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    var n;
    const a = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Q(t)
    }, s = this._parseSync({ data: t, path: a.path, parent: a });
    return hn(a, s);
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Q(t)
    }, a = this._parse({ data: t, path: n.path, parent: n }), s = await (ot(a) ? a : Promise.resolve(a));
    return hn(n, s);
  }
  refine(t, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, s) => {
      const o = t(a), c = () => s.addIssue({
        code: d.custom,
        ...n(a)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (c(), !1)) : o ? !0 : (c(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, a) => t(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(t) {
    return new U({
      schema: this,
      typeName: y.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  optional() {
    return z.create(this, this._def);
  }
  nullable() {
    return ce.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return D.create(this, this._def);
  }
  promise() {
    return ve.create(this, this._def);
  }
  or(t) {
    return Ie.create([this, t], this._def);
  }
  and(t) {
    return Ne.create(this, t, this._def);
  }
  transform(t) {
    return new U({
      ..._(this._def),
      schema: this,
      typeName: y.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new Ze({
      ..._(this._def),
      innerType: this,
      defaultValue: r,
      typeName: y.ZodDefault
    });
  }
  brand() {
    return new va({
      typeName: y.ZodBranded,
      type: this,
      ..._(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new dt({
      ..._(this._def),
      innerType: this,
      catchValue: r,
      typeName: y.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return qe.create(this, t);
  }
  readonly() {
    return pt.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const yh = /^c[^\s-]{8,}$/i, mh = /^[a-z][a-z0-9]*$/, gh = /^[0-9A-HJKMNP-TV-Z]{26}$/, _h = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, bh = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Th = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let zt;
const $h = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, Ah = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, Sh = (e) => e.precision ? e.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${e.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${e.precision}}Z$`) : e.precision === 0 ? e.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : e.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function wh(e, t) {
  return !!((t === "v4" || !t) && $h.test(e) || (t === "v6" || !t) && Ah.test(e));
}
class M extends b {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== f.string) {
      const s = this._getOrReturnCtx(t);
      return p(
        s,
        {
          code: d.invalid_type,
          expected: f.string,
          received: s.parsedType
        }
        //
      ), g;
    }
    const n = new R();
    let a;
    for (const s of this._def.checks)
      if (s.kind === "min")
        t.data.length < s.value && (a = this._getOrReturnCtx(t, a), p(a, {
          code: d.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "max")
        t.data.length > s.value && (a = this._getOrReturnCtx(t, a), p(a, {
          code: d.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "length") {
        const o = t.data.length > s.value, c = t.data.length < s.value;
        (o || c) && (a = this._getOrReturnCtx(t, a), o ? p(a, {
          code: d.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : c && p(a, {
          code: d.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), n.dirty());
      } else if (s.kind === "email")
        bh.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "email",
          code: d.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "emoji")
        zt || (zt = new RegExp(Th, "u")), zt.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "emoji",
          code: d.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "uuid")
        _h.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "uuid",
          code: d.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid")
        yh.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "cuid",
          code: d.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid2")
        mh.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "cuid2",
          code: d.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "ulid")
        gh.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "ulid",
          code: d.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "url")
        try {
          new URL(t.data);
        } catch {
          a = this._getOrReturnCtx(t, a), p(a, {
            validation: "url",
            code: d.invalid_string,
            message: s.message
          }), n.dirty();
        }
      else
        s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "regex",
          code: d.invalid_string,
          message: s.message
        }), n.dirty())) : s.kind === "trim" ? t.data = t.data.trim() : s.kind === "includes" ? t.data.includes(s.value, s.position) || (a = this._getOrReturnCtx(t, a), p(a, {
          code: d.invalid_string,
          validation: { includes: s.value, position: s.position },
          message: s.message
        }), n.dirty()) : s.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : s.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : s.kind === "startsWith" ? t.data.startsWith(s.value) || (a = this._getOrReturnCtx(t, a), p(a, {
          code: d.invalid_string,
          validation: { startsWith: s.value },
          message: s.message
        }), n.dirty()) : s.kind === "endsWith" ? t.data.endsWith(s.value) || (a = this._getOrReturnCtx(t, a), p(a, {
          code: d.invalid_string,
          validation: { endsWith: s.value },
          message: s.message
        }), n.dirty()) : s.kind === "datetime" ? Sh(s).test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          code: d.invalid_string,
          validation: "datetime",
          message: s.message
        }), n.dirty()) : s.kind === "ip" ? wh(t.data, s.version) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "ip",
          code: d.invalid_string,
          message: s.message
        }), n.dirty()) : $.assertNever(s);
    return { status: n.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((a) => t.test(a), {
      validation: r,
      code: d.invalid_string,
      ...v.errToObj(n)
    });
  }
  _addCheck(t) {
    return new M({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...v.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...v.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...v.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...v.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...v.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...v.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...v.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...v.errToObj(t) });
  }
  datetime(t) {
    var r;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (r = t == null ? void 0 : t.offset) !== null && r !== void 0 ? r : !1,
      ...v.errToObj(t == null ? void 0 : t.message)
    });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...v.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r == null ? void 0 : r.position,
      ...v.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...v.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...v.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...v.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...v.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...v.errToObj(r)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(t) {
    return this.min(1, v.errToObj(t));
  }
  trim() {
    return new M({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new M({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new M({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
M.create = (e) => {
  var t;
  return new M({
    checks: [],
    typeName: y.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ..._(e)
  });
};
function xh(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, a = r > n ? r : n, s = parseInt(e.toFixed(a).replace(".", "")), o = parseInt(t.toFixed(a).replace(".", ""));
  return s % o / Math.pow(10, a);
}
class J extends b {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== f.number) {
      const s = this._getOrReturnCtx(t);
      return p(s, {
        code: d.invalid_type,
        expected: f.number,
        received: s.parsedType
      }), g;
    }
    let n;
    const a = new R();
    for (const s of this._def.checks)
      s.kind === "int" ? $.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), a.dirty()) : s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? xh(t.data, s.value) !== 0 && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : s.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.not_finite,
        message: s.message
      }), a.dirty()) : $.assertNever(s);
    return { status: a.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, v.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, v.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, v.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, v.toString(r));
  }
  setLimit(t, r, n, a) {
    return new J({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: v.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new J({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: v.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: v.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: v.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: v.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: v.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: v.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: v.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: v.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: v.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && $.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
J.create = (e) => new J({
  checks: [],
  typeName: y.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ..._(e)
});
class Y extends b {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = BigInt(t.data)), this._getType(t) !== f.bigint) {
      const s = this._getOrReturnCtx(t);
      return p(s, {
        code: d.invalid_type,
        expected: f.bigint,
        received: s.parsedType
      }), g;
    }
    let n;
    const a = new R();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? t.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : $.assertNever(s);
    return { status: a.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, v.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, v.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, v.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, v.toString(r));
  }
  setLimit(t, r, n, a) {
    return new Y({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: v.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Y({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: v.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: v.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: v.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: v.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: v.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Y.create = (e) => {
  var t;
  return new Y({
    checks: [],
    typeName: y.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ..._(e)
  });
};
class ke extends b {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== f.boolean) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: f.boolean,
        received: n.parsedType
      }), g;
    }
    return P(t.data);
  }
}
ke.create = (e) => new ke({
  typeName: y.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ..._(e)
});
class ie extends b {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== f.date) {
      const s = this._getOrReturnCtx(t);
      return p(s, {
        code: d.invalid_type,
        expected: f.date,
        received: s.parsedType
      }), g;
    }
    if (isNaN(t.data.getTime())) {
      const s = this._getOrReturnCtx(t);
      return p(s, {
        code: d.invalid_date
      }), g;
    }
    const n = new R();
    let a;
    for (const s of this._def.checks)
      s.kind === "min" ? t.data.getTime() < s.value && (a = this._getOrReturnCtx(t, a), p(a, {
        code: d.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), n.dirty()) : s.kind === "max" ? t.data.getTime() > s.value && (a = this._getOrReturnCtx(t, a), p(a, {
        code: d.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), n.dirty()) : $.assertNever(s);
    return {
      status: n.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new ie({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: v.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: v.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
ie.create = (e) => new ie({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: y.ZodDate,
  ..._(e)
});
class ct extends b {
  _parse(t) {
    if (this._getType(t) !== f.symbol) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: f.symbol,
        received: n.parsedType
      }), g;
    }
    return P(t.data);
  }
}
ct.create = (e) => new ct({
  typeName: y.ZodSymbol,
  ..._(e)
});
class Ce extends b {
  _parse(t) {
    if (this._getType(t) !== f.undefined) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: f.undefined,
        received: n.parsedType
      }), g;
    }
    return P(t.data);
  }
}
Ce.create = (e) => new Ce({
  typeName: y.ZodUndefined,
  ..._(e)
});
class Re extends b {
  _parse(t) {
    if (this._getType(t) !== f.null) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: f.null,
        received: n.parsedType
      }), g;
    }
    return P(t.data);
  }
}
Re.create = (e) => new Re({
  typeName: y.ZodNull,
  ..._(e)
});
class he extends b {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return P(t.data);
  }
}
he.create = (e) => new he({
  typeName: y.ZodAny,
  ..._(e)
});
class se extends b {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return P(t.data);
  }
}
se.create = (e) => new se({
  typeName: y.ZodUnknown,
  ..._(e)
});
class K extends b {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return p(r, {
      code: d.invalid_type,
      expected: f.never,
      received: r.parsedType
    }), g;
  }
}
K.create = (e) => new K({
  typeName: y.ZodNever,
  ..._(e)
});
class ut extends b {
  _parse(t) {
    if (this._getType(t) !== f.undefined) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: f.void,
        received: n.parsedType
      }), g;
    }
    return P(t.data);
  }
}
ut.create = (e) => new ut({
  typeName: y.ZodVoid,
  ..._(e)
});
class D extends b {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), a = this._def;
    if (r.parsedType !== f.array)
      return p(r, {
        code: d.invalid_type,
        expected: f.array,
        received: r.parsedType
      }), g;
    if (a.exactLength !== null) {
      const o = r.data.length > a.exactLength.value, c = r.data.length < a.exactLength.value;
      (o || c) && (p(r, {
        code: o ? d.too_big : d.too_small,
        minimum: c ? a.exactLength.value : void 0,
        maximum: o ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (p(r, {
      code: d.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (p(r, {
      code: d.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, c) => a.type._parseAsync(new q(r, o, r.path, c)))).then((o) => R.mergeArray(n, o));
    const s = [...r.data].map((o, c) => a.type._parseSync(new q(r, o, r.path, c)));
    return R.mergeArray(n, s);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new D({
      ...this._def,
      minLength: { value: t, message: v.toString(r) }
    });
  }
  max(t, r) {
    return new D({
      ...this._def,
      maxLength: { value: t, message: v.toString(r) }
    });
  }
  length(t, r) {
    return new D({
      ...this._def,
      exactLength: { value: t, message: v.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
D.create = (e, t) => new D({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: y.ZodArray,
  ..._(t)
});
function fe(e) {
  if (e instanceof x) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = z.create(fe(n));
    }
    return new x({
      ...e._def,
      shape: () => t
    });
  } else
    return e instanceof D ? new D({
      ...e._def,
      type: fe(e.element)
    }) : e instanceof z ? z.create(fe(e.unwrap())) : e instanceof ce ? ce.create(fe(e.unwrap())) : e instanceof H ? H.create(e.items.map((t) => fe(t))) : e;
}
class x extends b {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = $.objectKeys(t);
    return this._cached = { shape: t, keys: r };
  }
  _parse(t) {
    if (this._getType(t) !== f.object) {
      const u = this._getOrReturnCtx(t);
      return p(u, {
        code: d.invalid_type,
        expected: f.object,
        received: u.parsedType
      }), g;
    }
    const { status: n, ctx: a } = this._processInputParams(t), { shape: s, keys: o } = this._getCached(), c = [];
    if (!(this._def.catchall instanceof K && this._def.unknownKeys === "strip"))
      for (const u in a.data)
        o.includes(u) || c.push(u);
    const l = [];
    for (const u of o) {
      const h = s[u], T = a.data[u];
      l.push({
        key: { status: "valid", value: u },
        value: h._parse(new q(a, T, a.path, u)),
        alwaysSet: u in a.data
      });
    }
    if (this._def.catchall instanceof K) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const h of c)
          l.push({
            key: { status: "valid", value: h },
            value: { status: "valid", value: a.data[h] }
          });
      else if (u === "strict")
        c.length > 0 && (p(a, {
          code: d.unrecognized_keys,
          keys: c
        }), n.dirty());
      else if (u !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const h of c) {
        const T = a.data[h];
        l.push({
          key: { status: "valid", value: h },
          value: u._parse(
            new q(a, T, a.path, h)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: h in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const h of l) {
        const T = await h.key;
        u.push({
          key: T,
          value: await h.value,
          alwaysSet: h.alwaysSet
        });
      }
      return u;
    }).then((u) => R.mergeObjectSync(n, u)) : R.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return v.errToObj, new x({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          var a, s, o, c;
          const l = (o = (s = (a = this._def).errorMap) === null || s === void 0 ? void 0 : s.call(a, r, n).message) !== null && o !== void 0 ? o : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (c = v.errToObj(t).message) !== null && c !== void 0 ? c : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new x({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new x({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new x({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new x({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: y.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new x({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    return $.objectKeys(t).forEach((n) => {
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new x({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    return $.objectKeys(this.shape).forEach((n) => {
      t[n] || (r[n] = this.shape[n]);
    }), new x({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return fe(this);
  }
  partial(t) {
    const r = {};
    return $.objectKeys(this.shape).forEach((n) => {
      const a = this.shape[n];
      t && !t[n] ? r[n] = a : r[n] = a.optional();
    }), new x({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    return $.objectKeys(this.shape).forEach((n) => {
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let s = this.shape[n];
        for (; s instanceof z; )
          s = s._def.innerType;
        r[n] = s;
      }
    }), new x({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return ha($.objectKeys(this.shape));
  }
}
x.create = (e, t) => new x({
  shape: () => e,
  unknownKeys: "strip",
  catchall: K.create(),
  typeName: y.ZodObject,
  ..._(t)
});
x.strictCreate = (e, t) => new x({
  shape: () => e,
  unknownKeys: "strict",
  catchall: K.create(),
  typeName: y.ZodObject,
  ..._(t)
});
x.lazycreate = (e, t) => new x({
  shape: e,
  unknownKeys: "strip",
  catchall: K.create(),
  typeName: y.ZodObject,
  ..._(t)
});
class Ie extends b {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function a(s) {
      for (const c of s)
        if (c.result.status === "valid")
          return c.result;
      for (const c of s)
        if (c.result.status === "dirty")
          return r.common.issues.push(...c.ctx.common.issues), c.result;
      const o = s.map((c) => new Z(c.ctx.common.issues));
      return p(r, {
        code: d.invalid_union,
        unionErrors: o
      }), g;
    }
    if (r.common.async)
      return Promise.all(n.map(async (s) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(a);
    {
      let s;
      const o = [];
      for (const l of n) {
        const u = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, h = l._parseSync({
          data: r.data,
          path: r.path,
          parent: u
        });
        if (h.status === "valid")
          return h;
        h.status === "dirty" && !s && (s = { result: h, ctx: u }), u.common.issues.length && o.push(u.common.issues);
      }
      if (s)
        return r.common.issues.push(...s.ctx.common.issues), s.result;
      const c = o.map((l) => new Z(l));
      return p(r, {
        code: d.invalid_union,
        unionErrors: c
      }), g;
    }
  }
  get options() {
    return this._def.options;
  }
}
Ie.create = (e, t) => new Ie({
  options: e,
  typeName: y.ZodUnion,
  ..._(t)
});
const tt = (e) => e instanceof Le ? tt(e.schema) : e instanceof U ? tt(e.innerType()) : e instanceof Ve ? [e.value] : e instanceof X ? e.options : e instanceof Me ? Object.keys(e.enum) : e instanceof Ze ? tt(e._def.innerType) : e instanceof Ce ? [void 0] : e instanceof Re ? [null] : null;
class Ot extends b {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== f.object)
      return p(r, {
        code: d.invalid_type,
        expected: f.object,
        received: r.parsedType
      }), g;
    const n = this.discriminator, a = r.data[n], s = this.optionsMap.get(a);
    return s ? r.common.async ? s._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : s._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (p(r, {
      code: d.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), g);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const s of r) {
      const o = tt(s.shape[t]);
      if (!o)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const c of o) {
        if (a.has(c))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(c)}`);
        a.set(c, s);
      }
    }
    return new Ot({
      typeName: y.ZodDiscriminatedUnion,
      discriminator: t,
      options: r,
      optionsMap: a,
      ..._(n)
    });
  }
}
function ar(e, t) {
  const r = Q(e), n = Q(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === f.object && n === f.object) {
    const a = $.objectKeys(t), s = $.objectKeys(e).filter((c) => a.indexOf(c) !== -1), o = { ...e, ...t };
    for (const c of s) {
      const l = ar(e[c], t[c]);
      if (!l.valid)
        return { valid: !1 };
      o[c] = l.data;
    }
    return { valid: !0, data: o };
  } else if (r === f.array && n === f.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const a = [];
    for (let s = 0; s < e.length; s++) {
      const o = e[s], c = t[s], l = ar(o, c);
      if (!l.valid)
        return { valid: !1 };
      a.push(l.data);
    }
    return { valid: !0, data: a };
  } else
    return r === f.date && n === f.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Ne extends b {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = (s, o) => {
      if (rr(s) || rr(o))
        return g;
      const c = ar(s.value, o.value);
      return c.valid ? ((nr(s) || nr(o)) && r.dirty(), { status: r.value, value: c.data }) : (p(n, {
        code: d.invalid_intersection_types
      }), g);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([s, o]) => a(s, o)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Ne.create = (e, t, r) => new Ne({
  left: e,
  right: t,
  typeName: y.ZodIntersection,
  ..._(r)
});
class H extends b {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== f.array)
      return p(n, {
        code: d.invalid_type,
        expected: f.array,
        received: n.parsedType
      }), g;
    if (n.data.length < this._def.items.length)
      return p(n, {
        code: d.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), g;
    !this._def.rest && n.data.length > this._def.items.length && (p(n, {
      code: d.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const s = [...n.data].map((o, c) => {
      const l = this._def.items[c] || this._def.rest;
      return l ? l._parse(new q(n, o, n.path, c)) : null;
    }).filter((o) => !!o);
    return n.common.async ? Promise.all(s).then((o) => R.mergeArray(r, o)) : R.mergeArray(r, s);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new H({
      ...this._def,
      rest: t
    });
  }
}
H.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new H({
    items: e,
    typeName: y.ZodTuple,
    rest: null,
    ..._(t)
  });
};
class Pe extends b {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== f.object)
      return p(n, {
        code: d.invalid_type,
        expected: f.object,
        received: n.parsedType
      }), g;
    const a = [], s = this._def.keyType, o = this._def.valueType;
    for (const c in n.data)
      a.push({
        key: s._parse(new q(n, c, n.path, c)),
        value: o._parse(new q(n, n.data[c], n.path, c))
      });
    return n.common.async ? R.mergeObjectAsync(r, a) : R.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, r, n) {
    return r instanceof b ? new Pe({
      keyType: t,
      valueType: r,
      typeName: y.ZodRecord,
      ..._(n)
    }) : new Pe({
      keyType: M.create(),
      valueType: t,
      typeName: y.ZodRecord,
      ..._(r)
    });
  }
}
class lt extends b {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== f.map)
      return p(n, {
        code: d.invalid_type,
        expected: f.map,
        received: n.parsedType
      }), g;
    const a = this._def.keyType, s = this._def.valueType, o = [...n.data.entries()].map(([c, l], u) => ({
      key: a._parse(new q(n, c, n.path, [u, "key"])),
      value: s._parse(new q(n, l, n.path, [u, "value"]))
    }));
    if (n.common.async) {
      const c = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const u = await l.key, h = await l.value;
          if (u.status === "aborted" || h.status === "aborted")
            return g;
          (u.status === "dirty" || h.status === "dirty") && r.dirty(), c.set(u.value, h.value);
        }
        return { status: r.value, value: c };
      });
    } else {
      const c = /* @__PURE__ */ new Map();
      for (const l of o) {
        const u = l.key, h = l.value;
        if (u.status === "aborted" || h.status === "aborted")
          return g;
        (u.status === "dirty" || h.status === "dirty") && r.dirty(), c.set(u.value, h.value);
      }
      return { status: r.value, value: c };
    }
  }
}
lt.create = (e, t, r) => new lt({
  valueType: t,
  keyType: e,
  typeName: y.ZodMap,
  ..._(r)
});
class oe extends b {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== f.set)
      return p(n, {
        code: d.invalid_type,
        expected: f.set,
        received: n.parsedType
      }), g;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (p(n, {
      code: d.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (p(n, {
      code: d.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const s = this._def.valueType;
    function o(l) {
      const u = /* @__PURE__ */ new Set();
      for (const h of l) {
        if (h.status === "aborted")
          return g;
        h.status === "dirty" && r.dirty(), u.add(h.value);
      }
      return { status: r.value, value: u };
    }
    const c = [...n.data.values()].map((l, u) => s._parse(new q(n, l, n.path, u)));
    return n.common.async ? Promise.all(c).then((l) => o(l)) : o(c);
  }
  min(t, r) {
    return new oe({
      ...this._def,
      minSize: { value: t, message: v.toString(r) }
    });
  }
  max(t, r) {
    return new oe({
      ...this._def,
      maxSize: { value: t, message: v.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
oe.create = (e, t) => new oe({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: y.ZodSet,
  ..._(t)
});
class pe extends b {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== f.function)
      return p(r, {
        code: d.invalid_type,
        expected: f.function,
        received: r.parsedType
      }), g;
    function n(c, l) {
      return it({
        data: c,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          st(),
          Oe
        ].filter((u) => !!u),
        issueData: {
          code: d.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function a(c, l) {
      return it({
        data: c,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          st(),
          Oe
        ].filter((u) => !!u),
        issueData: {
          code: d.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const s = { errorMap: r.common.contextualErrorMap }, o = r.data;
    if (this._def.returns instanceof ve) {
      const c = this;
      return P(async function(...l) {
        const u = new Z([]), h = await c._def.args.parseAsync(l, s).catch((C) => {
          throw u.addIssue(n(l, C)), u;
        }), T = await Reflect.apply(o, this, h);
        return await c._def.returns._def.type.parseAsync(T, s).catch((C) => {
          throw u.addIssue(a(T, C)), u;
        });
      });
    } else {
      const c = this;
      return P(function(...l) {
        const u = c._def.args.safeParse(l, s);
        if (!u.success)
          throw new Z([n(l, u.error)]);
        const h = Reflect.apply(o, this, u.data), T = c._def.returns.safeParse(h, s);
        if (!T.success)
          throw new Z([a(h, T.error)]);
        return T.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new pe({
      ...this._def,
      args: H.create(t).rest(se.create())
    });
  }
  returns(t) {
    return new pe({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, r, n) {
    return new pe({
      args: t || H.create([]).rest(se.create()),
      returns: r || se.create(),
      typeName: y.ZodFunction,
      ..._(n)
    });
  }
}
class Le extends b {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
Le.create = (e, t) => new Le({
  getter: e,
  typeName: y.ZodLazy,
  ..._(t)
});
class Ve extends b {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return p(r, {
        received: r.data,
        code: d.invalid_literal,
        expected: this._def.value
      }), g;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Ve.create = (e, t) => new Ve({
  value: e,
  typeName: y.ZodLiteral,
  ..._(t)
});
function ha(e, t) {
  return new X({
    values: e,
    typeName: y.ZodEnum,
    ..._(t)
  });
}
class X extends b {
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return p(r, {
        expected: $.joinValues(n),
        received: r.parsedType,
        code: d.invalid_type
      }), g;
    }
    if (this._def.values.indexOf(t.data) === -1) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return p(r, {
        received: r.data,
        code: d.invalid_enum_value,
        options: n
      }), g;
    }
    return P(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t) {
    return X.create(t);
  }
  exclude(t) {
    return X.create(this.options.filter((r) => !t.includes(r)));
  }
}
X.create = ha;
class Me extends b {
  _parse(t) {
    const r = $.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== f.string && n.parsedType !== f.number) {
      const a = $.objectValues(r);
      return p(n, {
        expected: $.joinValues(a),
        received: n.parsedType,
        code: d.invalid_type
      }), g;
    }
    if (r.indexOf(t.data) === -1) {
      const a = $.objectValues(r);
      return p(n, {
        received: n.data,
        code: d.invalid_enum_value,
        options: a
      }), g;
    }
    return P(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Me.create = (e, t) => new Me({
  values: e,
  typeName: y.ZodNativeEnum,
  ..._(t)
});
class ve extends b {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== f.promise && r.common.async === !1)
      return p(r, {
        code: d.invalid_type,
        expected: f.promise,
        received: r.parsedType
      }), g;
    const n = r.parsedType === f.promise ? r.data : Promise.resolve(r.data);
    return P(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
ve.create = (e, t) => new ve({
  type: e,
  typeName: y.ZodPromise,
  ..._(t)
});
class U extends b {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === y.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = this._def.effect || null, s = {
      addIssue: (o) => {
        p(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), a.type === "preprocess") {
      const o = a.transform(n.data, s);
      return n.common.issues.length ? {
        status: "dirty",
        value: n.data
      } : n.common.async ? Promise.resolve(o).then((c) => this._def.schema._parseAsync({
        data: c,
        path: n.path,
        parent: n
      })) : this._def.schema._parseSync({
        data: o,
        path: n.path,
        parent: n
      });
    }
    if (a.type === "refinement") {
      const o = (c) => {
        const l = a.refinement(c, s);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return c;
      };
      if (n.common.async === !1) {
        const c = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return c.status === "aborted" ? g : (c.status === "dirty" && r.dirty(), o(c.value), { status: r.value, value: c.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((c) => c.status === "aborted" ? g : (c.status === "dirty" && r.dirty(), o(c.value).then(() => ({ status: r.value, value: c.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!je(o))
          return o;
        const c = a.transform(o.value, s);
        if (c instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: c };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => je(o) ? Promise.resolve(a.transform(o.value, s)).then((c) => ({ status: r.value, value: c })) : o);
    $.assertNever(a);
  }
}
U.create = (e, t, r) => new U({
  schema: e,
  typeName: y.ZodEffects,
  effect: t,
  ..._(r)
});
U.createWithPreprocess = (e, t, r) => new U({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: y.ZodEffects,
  ..._(r)
});
class z extends b {
  _parse(t) {
    return this._getType(t) === f.undefined ? P(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
z.create = (e, t) => new z({
  innerType: e,
  typeName: y.ZodOptional,
  ..._(t)
});
class ce extends b {
  _parse(t) {
    return this._getType(t) === f.null ? P(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ce.create = (e, t) => new ce({
  innerType: e,
  typeName: y.ZodNullable,
  ..._(t)
});
class Ze extends b {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === f.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Ze.create = (e, t) => new Ze({
  innerType: e,
  typeName: y.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ..._(t)
});
class dt extends b {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return ot(a) ? a.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new Z(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new Z(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
dt.create = (e, t) => new dt({
  innerType: e,
  typeName: y.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ..._(t)
});
class ft extends b {
  _parse(t) {
    if (this._getType(t) !== f.nan) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: f.nan,
        received: n.parsedType
      }), g;
    }
    return { status: "valid", value: t.data };
  }
}
ft.create = (e) => new ft({
  typeName: y.ZodNaN,
  ..._(e)
});
const Eh = Symbol("zod_brand");
class va extends b {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class qe extends b {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? g : s.status === "dirty" ? (r.dirty(), pa(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? g : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new qe({
      in: t,
      out: r,
      typeName: y.ZodPipeline
    });
  }
}
class pt extends b {
  _parse(t) {
    const r = this._def.innerType._parse(t);
    return je(r) && (r.value = Object.freeze(r.value)), r;
  }
}
pt.create = (e, t) => new pt({
  innerType: e,
  typeName: y.ZodReadonly,
  ..._(t)
});
const ya = (e, t = {}, r) => e ? he.create().superRefine((n, a) => {
  var s, o;
  if (!e(n)) {
    const c = typeof t == "function" ? t(n) : typeof t == "string" ? { message: t } : t, l = (o = (s = c.fatal) !== null && s !== void 0 ? s : r) !== null && o !== void 0 ? o : !0, u = typeof c == "string" ? { message: c } : c;
    a.addIssue({ code: "custom", ...u, fatal: l });
  }
}) : he.create(), Oh = {
  object: x.lazycreate
};
var y;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(y || (y = {}));
const jh = (e, t = {
  message: `Input not instance of ${e.name}`
}) => ya((r) => r instanceof e, t), ma = M.create, ga = J.create, kh = ft.create, Ch = Y.create, _a = ke.create, Rh = ie.create, Ih = ct.create, Nh = Ce.create, Ph = Re.create, Lh = he.create, Vh = se.create, Mh = K.create, Zh = ut.create, Dh = D.create, Uh = x.create, qh = x.strictCreate, Hh = Ie.create, Bh = Ot.create, Gh = Ne.create, zh = H.create, Kh = Pe.create, Fh = lt.create, Qh = oe.create, Wh = pe.create, Jh = Le.create, Yh = Ve.create, Xh = X.create, ev = Me.create, tv = ve.create, vn = U.create, rv = z.create, nv = ce.create, av = U.createWithPreprocess, sv = qe.create, iv = () => ma().optional(), ov = () => ga().optional(), cv = () => _a().optional(), uv = {
  string: (e) => M.create({ ...e, coerce: !0 }),
  number: (e) => J.create({ ...e, coerce: !0 }),
  boolean: (e) => ke.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => Y.create({ ...e, coerce: !0 }),
  date: (e) => ie.create({ ...e, coerce: !0 })
}, lv = g;
var i = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: Oe,
  setErrorMap: hh,
  getErrorMap: st,
  makeIssue: it,
  EMPTY_PATH: vh,
  addIssueToContext: p,
  ParseStatus: R,
  INVALID: g,
  DIRTY: pa,
  OK: P,
  isAborted: rr,
  isDirty: nr,
  isValid: je,
  isAsync: ot,
  get util() {
    return $;
  },
  get objectUtil() {
    return tr;
  },
  ZodParsedType: f,
  getParsedType: Q,
  ZodType: b,
  ZodString: M,
  ZodNumber: J,
  ZodBigInt: Y,
  ZodBoolean: ke,
  ZodDate: ie,
  ZodSymbol: ct,
  ZodUndefined: Ce,
  ZodNull: Re,
  ZodAny: he,
  ZodUnknown: se,
  ZodNever: K,
  ZodVoid: ut,
  ZodArray: D,
  ZodObject: x,
  ZodUnion: Ie,
  ZodDiscriminatedUnion: Ot,
  ZodIntersection: Ne,
  ZodTuple: H,
  ZodRecord: Pe,
  ZodMap: lt,
  ZodSet: oe,
  ZodFunction: pe,
  ZodLazy: Le,
  ZodLiteral: Ve,
  ZodEnum: X,
  ZodNativeEnum: Me,
  ZodPromise: ve,
  ZodEffects: U,
  ZodTransformer: U,
  ZodOptional: z,
  ZodNullable: ce,
  ZodDefault: Ze,
  ZodCatch: dt,
  ZodNaN: ft,
  BRAND: Eh,
  ZodBranded: va,
  ZodPipeline: qe,
  ZodReadonly: pt,
  custom: ya,
  Schema: b,
  ZodSchema: b,
  late: Oh,
  get ZodFirstPartyTypeKind() {
    return y;
  },
  coerce: uv,
  any: Lh,
  array: Dh,
  bigint: Ch,
  boolean: _a,
  date: Rh,
  discriminatedUnion: Bh,
  effect: vn,
  enum: Xh,
  function: Wh,
  instanceof: jh,
  intersection: Gh,
  lazy: Jh,
  literal: Yh,
  map: Fh,
  nan: kh,
  nativeEnum: ev,
  never: Mh,
  null: Ph,
  nullable: nv,
  number: ga,
  object: Uh,
  oboolean: cv,
  onumber: ov,
  optional: rv,
  ostring: iv,
  pipeline: sv,
  preprocess: av,
  promise: tv,
  record: Kh,
  set: Qh,
  strictObject: qh,
  string: ma,
  symbol: Ih,
  transformer: vn,
  tuple: zh,
  undefined: Nh,
  union: Hh,
  unknown: Vh,
  void: Zh,
  NEVER: lv,
  ZodIssueCode: d,
  quotelessJson: ph,
  ZodError: Z
}), I = (e) => e, dv = class {
  /**
   * @package
   */
  constructor(e, t, r) {
    this.versionMap = e, this.latestVersion = t, this.getVersion = r;
  }
  /**
   * Returns whether the given data is a valid entity of any version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of any version of the entity.
   */
  is(e) {
    let t = this.getVersion(e);
    if (t === null)
      return !1;
    const r = this.versionMap[t];
    return r ? r.schema.safeParse(e).success : !1;
  }
  /**
   * Returns whether the given data is a valid entity of the latest version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of the latest version of the entity.
   */
  isLatest(e) {
    return this.versionMap[this.latestVersion].schema.safeParse(e).success;
  }
  /**
   * Similar to Zod's `safeParse` method, but also migrates the data to the latest version.
   * @param data The data to parse
   * @returns The result from parsing data, if successful, older versions are migrated to the latest version
   */
  safeParse(e) {
    const t = this.getVersion(e);
    if (t === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    const r = this.versionMap[t];
    if (!r)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = r.schema.safeParse(e);
    if (!n.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: t,
          versionDef: r,
          error: n.error
        }
      };
    let a = e;
    for (let s = t + 1; s <= this.latestVersion; s++) {
      const o = this.versionMap[s];
      if (!o)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: s }
        };
      if (o.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: s }
        };
      a = o.up(a);
    }
    return { type: "ok", value: a };
  }
};
function jt(e) {
  return new dv(e.versionMap, e.latestVersion, e.getVersion);
}
function ht(e) {
  return i.custom((t) => e.is(t)).transform((t) => {
    const r = e.safeParse(t);
    if (r.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.is` returned success, safeParse failed."
      );
    return r.value;
  });
}
var fv = "__lodash_hash_undefined__";
function pv(e) {
  return this.__data__.set(e, fv), this;
}
var hv = pv;
function vv(e) {
  return this.__data__.has(e);
}
var yv = vv, mv = Gn, gv = hv, _v = yv;
function vt(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new mv(); ++t < r; )
    this.add(e[t]);
}
vt.prototype.add = vt.prototype.push = gv;
vt.prototype.has = _v;
var bv = vt;
function Tv(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var $v = Tv;
function Av(e, t) {
  return e.has(t);
}
var Sv = Av, wv = bv, xv = $v, Ev = Sv, Ov = 1, jv = 2;
function kv(e, t, r, n, a, s) {
  var o = r & Ov, c = e.length, l = t.length;
  if (c != l && !(o && l > c))
    return !1;
  var u = s.get(e), h = s.get(t);
  if (u && h)
    return u == t && h == e;
  var T = -1, A = !0, C = r & jv ? new wv() : void 0;
  for (s.set(e, t), s.set(t, e); ++T < c; ) {
    var L = e[T], V = t[T];
    if (n)
      var k = o ? n(V, L, T, t, e, s) : n(L, V, T, e, t, s);
    if (k !== void 0) {
      if (k)
        continue;
      A = !1;
      break;
    }
    if (C) {
      if (!xv(t, function(N, ne) {
        if (!Ev(C, ne) && (L === N || a(L, N, r, n, s)))
          return C.push(ne);
      })) {
        A = !1;
        break;
      }
    } else if (!(L === V || a(L, V, r, n, s))) {
      A = !1;
      break;
    }
  }
  return s.delete(e), s.delete(t), A;
}
var ba = kv;
function Cv(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var Rv = Cv;
function Iv(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var Nv = Iv, yn = Tt, mn = ca, Pv = lr, Lv = ba, Vv = Rv, Mv = Nv, Zv = 1, Dv = 2, Uv = "[object Boolean]", qv = "[object Date]", Hv = "[object Error]", Bv = "[object Map]", Gv = "[object Number]", zv = "[object RegExp]", Kv = "[object Set]", Fv = "[object String]", Qv = "[object Symbol]", Wv = "[object ArrayBuffer]", Jv = "[object DataView]", gn = yn ? yn.prototype : void 0, Kt = gn ? gn.valueOf : void 0;
function Yv(e, t, r, n, a, s, o) {
  switch (r) {
    case Jv:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Wv:
      return !(e.byteLength != t.byteLength || !s(new mn(e), new mn(t)));
    case Uv:
    case qv:
    case Gv:
      return Pv(+e, +t);
    case Hv:
      return e.name == t.name && e.message == t.message;
    case zv:
    case Fv:
      return e == t + "";
    case Bv:
      var c = Vv;
    case Kv:
      var l = n & Zv;
      if (c || (c = Mv), e.size != t.size && !l)
        return !1;
      var u = o.get(e);
      if (u)
        return u == t;
      n |= Dv, o.set(e, t);
      var h = Lv(c(e), c(t), n, a, s, o);
      return o.delete(e), h;
    case Qv:
      if (Kt)
        return Kt.call(e) == Kt.call(t);
  }
  return !1;
}
var Xv = Yv, _n = ia, ey = 1, ty = Object.prototype, ry = ty.hasOwnProperty;
function ny(e, t, r, n, a, s) {
  var o = r & ey, c = _n(e), l = c.length, u = _n(t), h = u.length;
  if (l != h && !o)
    return !1;
  for (var T = l; T--; ) {
    var A = c[T];
    if (!(o ? A in t : ry.call(t, A)))
      return !1;
  }
  var C = s.get(e), L = s.get(t);
  if (C && L)
    return C == t && L == e;
  var V = !0;
  s.set(e, t), s.set(t, e);
  for (var k = o; ++T < l; ) {
    A = c[T];
    var N = e[A], ne = t[A];
    if (n)
      var Dr = o ? n(ne, N, A, t, e, s) : n(N, ne, A, e, t, s);
    if (!(Dr === void 0 ? N === ne || a(N, ne, r, n, s) : Dr)) {
      V = !1;
      break;
    }
    k || (k = A == "constructor");
  }
  if (V && !k) {
    var We = e.constructor, Je = t.constructor;
    We != Je && "constructor" in e && "constructor" in t && !(typeof We == "function" && We instanceof We && typeof Je == "function" && Je instanceof Je) && (V = !1);
  }
  return s.delete(e), s.delete(t), V;
}
var ay = ny, Ft = zn, sy = ba, iy = Xv, oy = ay, bn = Et, Tn = xt, $n = fr, cy = Jn, uy = 1, An = "[object Arguments]", Sn = "[object Array]", Xe = "[object Object]", ly = Object.prototype, wn = ly.hasOwnProperty;
function dy(e, t, r, n, a, s) {
  var o = Tn(e), c = Tn(t), l = o ? Sn : bn(e), u = c ? Sn : bn(t);
  l = l == An ? Xe : l, u = u == An ? Xe : u;
  var h = l == Xe, T = u == Xe, A = l == u;
  if (A && $n(e)) {
    if (!$n(t))
      return !1;
    o = !0, h = !1;
  }
  if (A && !h)
    return s || (s = new Ft()), o || cy(e) ? sy(e, t, r, n, a, s) : iy(e, t, l, r, n, a, s);
  if (!(r & uy)) {
    var C = h && wn.call(e, "__wrapped__"), L = T && wn.call(t, "__wrapped__");
    if (C || L) {
      var V = C ? e.value() : e, k = L ? t.value() : t;
      return s || (s = new Ft()), a(V, k, r, n, s);
    }
  }
  return A ? (s || (s = new Ft()), oy(e, t, r, n, a, s)) : !1;
}
var fy = dy, py = fy, xn = Se;
function Ta(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !xn(e) && !xn(t) ? e !== e && t !== t : py(e, t, r, n, Ta, a);
}
var hy = Ta, vy = hy;
function yy(e, t) {
  return vy(e, t);
}
var my = yy;
const gy = /* @__PURE__ */ Dn(my), _y = (e) => ({
  equals(t, r) {
    return t !== void 0 && r !== void 0 ? e.equals(t, r) : t === void 0 && r === void 0;
  }
}), Qt = (e, t) => ({
  equals(r, n) {
    return t.equals(e(r), e(n));
  }
}), Ee = {
  equals(e, t) {
    return gy(e, t);
  }
}, by = i.object({
  id: i.optional(i.string()),
  // Firebase Firestore ID
  url: i.string(),
  path: i.string(),
  headers: i.array(
    i.object({
      key: i.string(),
      value: i.string(),
      active: i.boolean()
    })
  ),
  params: i.array(
    i.object({
      key: i.string(),
      value: i.string(),
      active: i.boolean()
    })
  ),
  name: i.string(),
  method: i.string(),
  preRequestScript: i.string(),
  testScript: i.string(),
  contentType: i.string(),
  body: i.string(),
  rawParams: i.optional(i.string()),
  auth: i.optional(i.string()),
  httpUser: i.optional(i.string()),
  httpPassword: i.optional(i.string()),
  bearerToken: i.optional(i.string())
}), En = I({
  initial: !0,
  schema: by
}), br = i.object({
  key: i.string(),
  active: i.boolean()
}).and(
  i.union([
    i.object({
      isFile: i.literal(!0),
      value: i.array(i.instanceof(Blob).nullable())
    }),
    i.object({
      isFile: i.literal(!1),
      value: i.string()
    })
  ])
), Sg = i.object({
  contentType: i.literal("multipart/form-data"),
  body: i.array(br)
}), Ty = i.union([
  i.object({
    contentType: i.literal(null),
    body: i.literal(null).catch(null)
  }),
  i.object({
    contentType: i.literal("multipart/form-data"),
    body: i.array(br).catch([])
  }),
  i.object({
    contentType: i.union([
      i.literal("application/json"),
      i.literal("application/ld+json"),
      i.literal("application/hal+json"),
      i.literal("application/vnd.api+json"),
      i.literal("application/xml"),
      i.literal("application/x-www-form-urlencoded"),
      i.literal("text/html"),
      i.literal("text/plain")
    ]),
    body: i.string().catch("")
  })
]), kt = i.object({
  authType: i.literal("none")
}), Ct = i.object({
  authType: i.literal("basic"),
  username: i.string().catch(""),
  password: i.string().catch("")
}), Rt = i.object({
  authType: i.literal("bearer"),
  token: i.string().catch("")
}), $y = i.object({
  authType: i.literal("oauth-2"),
  token: i.string().catch(""),
  oidcDiscoveryURL: i.string().catch(""),
  authURL: i.string().catch(""),
  accessTokenURL: i.string().catch(""),
  clientID: i.string().catch(""),
  scope: i.string().catch("")
}), Tr = i.object({
  authType: i.literal("api-key"),
  key: i.string().catch(""),
  value: i.string().catch(""),
  addTo: i.string().catch("Headers")
}), It = i.object({
  authType: i.literal("inherit")
}), Ay = i.discriminatedUnion("authType", [
  kt,
  It,
  Ct,
  Rt,
  $y,
  Tr
]).and(
  i.object({
    authActive: i.boolean()
  })
), $a = i.array(
  i.object({
    key: i.string().catch(""),
    value: i.string().catch(""),
    active: i.boolean().catch(!0)
  })
), $r = i.array(
  i.object({
    key: i.string().catch(""),
    value: i.string().catch(""),
    active: i.boolean().catch(!0)
  })
), Aa = i.object({
  v: i.literal("1"),
  id: i.optional(i.string()),
  // Firebase Firestore ID
  name: i.string(),
  method: i.string(),
  endpoint: i.string(),
  params: $a,
  headers: $r,
  preRequestScript: i.string().catch(""),
  testScript: i.string().catch(""),
  auth: Ay,
  body: Ty
});
function Sy(e) {
  return {
    contentType: "application/json",
    body: e.contentType === "application/json" ? e.rawParams ?? "" : ""
  };
}
function wy(e) {
  return !e.auth || e.auth === "None" ? {
    authType: "none",
    authActive: !0
  } : e.auth === "Basic Auth" ? {
    authType: "basic",
    authActive: !0,
    username: e.httpUser ?? "",
    password: e.httpPassword ?? ""
  } : e.auth === "Bearer Token" ? {
    authType: "bearer",
    authActive: !0,
    token: e.bearerToken ?? ""
  } : { authType: "none", authActive: !0 };
}
const xy = I({
  initial: !1,
  schema: Aa,
  up(e) {
    const {
      url: t,
      path: r,
      headers: n,
      params: a,
      name: s,
      method: o,
      preRequestScript: c,
      testScript: l
    } = e, u = `${t}${r}`, h = Sy(e), T = wy(e), A = {
      v: "1",
      endpoint: u,
      headers: n,
      params: a,
      name: s,
      method: o,
      preRequestScript: c,
      testScript: l,
      body: h,
      auth: T
    };
    return e.id && (A.id = e.id), A;
  }
}), Sa = i.array(
  i.object({
    key: i.string().catch(""),
    value: i.string().catch(""),
    active: i.boolean().catch(!0)
  })
), wa = Aa.extend({
  v: i.literal("2"),
  requestVariables: Sa
}), Ey = I({
  initial: !1,
  schema: wa,
  up(e) {
    return {
      ...e,
      v: "2",
      requestVariables: []
    };
  }
}), xa = i.object({
  grantType: i.literal("AUTHORIZATION_CODE"),
  authEndpoint: i.string().trim(),
  tokenEndpoint: i.string().trim(),
  clientID: i.string().trim(),
  clientSecret: i.string().trim(),
  scopes: i.string().trim().optional(),
  token: i.string().catch(""),
  isPKCE: i.boolean(),
  codeVerifierMethod: i.union([i.literal("plain"), i.literal("S256")]).optional()
}), Ea = i.object({
  grantType: i.literal("CLIENT_CREDENTIALS"),
  authEndpoint: i.string().trim(),
  clientID: i.string().trim(),
  clientSecret: i.string().trim(),
  scopes: i.string().trim().optional(),
  token: i.string().catch("")
}), Oa = i.object({
  grantType: i.literal("PASSWORD"),
  authEndpoint: i.string().trim(),
  clientID: i.string().trim(),
  clientSecret: i.string().trim(),
  scopes: i.string().trim().optional(),
  username: i.string().trim(),
  password: i.string().trim(),
  token: i.string().catch("")
}), ja = i.object({
  grantType: i.literal("IMPLICIT"),
  authEndpoint: i.string().trim(),
  clientID: i.string().trim(),
  scopes: i.string().trim().optional(),
  token: i.string().catch("")
}), Ar = i.object({
  authType: i.literal("oauth-2"),
  grantTypeInfo: i.discriminatedUnion("grantType", [
    xa,
    Ea,
    Oa,
    ja
  ]),
  addTo: i.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Oy = i.discriminatedUnion("authType", [
  kt,
  It,
  Ct,
  Rt,
  Ar,
  Tr
]).and(
  i.object({
    authActive: i.boolean()
  })
), ka = wa.extend({
  v: i.literal("3"),
  auth: Oy
}), jy = I({
  initial: !1,
  schema: ka,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: a, authURL: s } = e.auth;
      return {
        ...e,
        v: "3",
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: "3",
      auth: {
        ...e.auth
      }
    };
  }
}), Ca = Tr.extend({
  addTo: i.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), ky = i.discriminatedUnion("authType", [
  kt,
  It,
  Ct,
  Rt,
  Ar,
  Ca
]).and(
  i.object({
    authActive: i.boolean()
  })
), Ra = ka.extend({
  v: i.literal("4"),
  auth: ky
}), Cy = I({
  schema: Ra,
  initial: !1,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: "4",
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      auth: {
        ...e.auth
      },
      v: "4"
    };
  }
}), Ry = xa.extend({
  clientSecret: i.string().optional()
}), Nt = Ar.extend({
  grantTypeInfo: i.discriminatedUnion("grantType", [
    Ry,
    Ea,
    Oa,
    ja
  ])
}), Sr = i.discriminatedUnion("authType", [
  kt,
  It,
  Ct,
  Rt,
  Nt,
  Ca
]).and(
  i.object({
    authActive: i.boolean()
  })
), Ia = Ra.extend({
  v: i.literal("5"),
  auth: Sr
}), Iy = I({
  schema: Ia,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "5"
    };
  }
}), Na = i.union([
  i.object({
    contentType: i.literal(null),
    body: i.literal(null).catch(null)
  }),
  i.object({
    contentType: i.literal("multipart/form-data"),
    body: i.array(br).catch([])
  }),
  i.object({
    contentType: i.union([
      i.literal("application/json"),
      i.literal("application/ld+json"),
      i.literal("application/hal+json"),
      i.literal("application/vnd.api+json"),
      i.literal("application/xml"),
      i.literal("text/xml"),
      i.literal("application/x-www-form-urlencoded"),
      i.literal("text/html"),
      i.literal("text/plain")
    ]),
    body: i.string().catch("")
  })
]), Ny = Ia.extend({
  v: i.literal("6"),
  body: Na
}), Py = I({
  schema: Ny,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "6"
    };
  }
}), Ly = {
  "application/json": "json",
  "application/ld+json": "json",
  "application/hal+json": "json",
  "application/vnd.api+json": "json",
  "application/xml": "xml",
  "text/xml": "xml",
  "application/x-www-form-urlencoded": "multipart",
  "multipart/form-data": "multipart",
  "text/html": "html",
  "text/plain": "plain"
}, wg = Object.keys(
  Ly
), Vy = i.object({
  // v is a stringified number
  v: i.string().regex(/^\d+$/).transform(Number)
}), Pt = jt({
  latestVersion: 6,
  versionMap: {
    0: En,
    1: xy,
    2: Ey,
    3: jy,
    4: Cy,
    5: Iy,
    6: Py
  },
  getVersion(e) {
    const t = Vy.safeParse(e);
    return t.success ? t.data.v : En.schema.safeParse(e).success ? 0 : null;
  }
}), My = gs({
  id: _y(F),
  v: F,
  auth: Ee,
  body: Ee,
  endpoint: F,
  headers: Qt(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    Ee
  ),
  params: Qt(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    Ee
  ),
  method: F,
  name: F,
  preRequestScript: F,
  testScript: F,
  requestVariables: Qt(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    Ee
  )
}), Pa = "6", xg = My.equals;
function Eg(e, t) {
  const r = fh(t);
  if (e && typeof e == "object") {
    if ("id" in e && typeof e.id == "string" && (r.id = e.id), "name" in e && typeof e.name == "string" && (r.name = e.name), "method" in e && typeof e.method == "string" && (r.method = e.method), "endpoint" in e && typeof e.endpoint == "string" && (r.endpoint = e.endpoint), "preRequestScript" in e && typeof e.preRequestScript == "string" && (r.preRequestScript = e.preRequestScript), "testScript" in e && typeof e.testScript == "string" && (r.testScript = e.testScript), "body" in e) {
      const n = Na.safeParse(e.body);
      n.success && (r.body = n.data);
    }
    if ("auth" in e) {
      const n = Sr.safeParse(e.auth);
      n.success && (r.auth = n.data);
    }
    if ("params" in e) {
      const n = $a.safeParse(e.params);
      n.success && (r.params = n.data);
    }
    if ("headers" in e) {
      const n = $r.safeParse(e.headers);
      n.success && (r.headers = n.data);
    }
    if ("requestVariables" in e) {
      const n = Sa.safeParse(e.requestVariables);
      n.success && (r.requestVariables = n.data);
    }
  }
  return r;
}
function Og(e) {
  return {
    v: Pa,
    ...e
  };
}
function Zy() {
  return {
    v: Pa,
    endpoint: "https://echo.hoppscotch.io",
    name: "Untitled",
    params: [],
    headers: [],
    method: "GET",
    auth: {
      authType: "inherit",
      authActive: !0
    },
    preRequestScript: "",
    testScript: "",
    body: {
      contentType: null,
      body: null
    },
    requestVariables: []
  };
}
function jg(e) {
  return Pt.isLatest(e);
}
function Dy(e) {
  const t = Pt.safeParse(e);
  return t.type === "ok" ? t.value : Zy();
}
const wr = i.object({
  key: i.string().catch(""),
  value: i.string().catch(""),
  active: i.boolean().catch(!0)
}), Uy = i.object({
  v: i.literal(1),
  name: i.string(),
  url: i.string(),
  headers: i.array(wr).catch([]),
  query: i.string(),
  variables: i.string()
}), qy = I({
  initial: !0,
  schema: Uy
}), Lt = i.object({
  authType: i.literal("none")
}), Vt = i.object({
  authType: i.literal("basic"),
  username: i.string().catch(""),
  password: i.string().catch("")
}), Mt = i.object({
  authType: i.literal("bearer"),
  token: i.string().catch("")
}), Hy = i.object({
  authType: i.literal("oauth-2"),
  token: i.string().catch(""),
  oidcDiscoveryURL: i.string().catch(""),
  authURL: i.string().catch(""),
  accessTokenURL: i.string().catch(""),
  clientID: i.string().catch(""),
  scope: i.string().catch("")
}), xr = i.object({
  authType: i.literal("api-key"),
  key: i.string().catch(""),
  value: i.string().catch(""),
  addTo: i.string().catch("Headers")
}), Zt = i.object({
  authType: i.literal("inherit")
}), By = i.discriminatedUnion("authType", [
  Lt,
  Vt,
  Mt,
  Hy,
  xr,
  Zt
]).and(
  i.object({
    authActive: i.boolean()
  })
), La = i.object({
  id: i.optional(i.string()),
  v: i.literal(2),
  name: i.string(),
  url: i.string(),
  headers: i.array(wr).catch([]),
  query: i.string(),
  variables: i.string(),
  auth: By
}), Gy = I({
  initial: !1,
  schema: La,
  up(e) {
    return {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "none"
      }
    };
  }
}), zy = i.discriminatedUnion("authType", [
  Lt,
  Zt,
  Vt,
  Mt,
  xr,
  Nt
  // both rest and gql have the same auth type for oauth2
]).and(
  i.object({
    authActive: i.boolean()
  })
), Va = La.extend({
  v: i.literal(3),
  auth: zy
}), Ky = I({
  initial: !1,
  schema: Va,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: a, authURL: s } = e.auth;
      return {
        ...e,
        v: 3,
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: 3,
      auth: {
        ...e.auth
      }
    };
  }
}), Ma = xr.extend({
  addTo: i.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Fy = i.discriminatedUnion("authType", [
  Lt,
  Zt,
  Vt,
  Mt,
  Ma,
  Nt
  // both rest and gql have the same auth type for oauth2
]).and(
  i.object({
    authActive: i.boolean()
  })
), Za = Va.extend({
  v: i.literal(4),
  auth: Fy
}), Qy = I({
  initial: !1,
  schema: Za,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: 4,
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      v: 4,
      auth: {
        ...e.auth
      }
    };
  }
}), Da = i.discriminatedUnion("authType", [
  Lt,
  Zt,
  Vt,
  Mt,
  Ma,
  Nt
  // both rest and gql have the same auth type for oauth2
]).and(
  i.object({
    authActive: i.boolean()
  })
), Wy = Za.extend({
  v: i.literal(5),
  auth: Da
}), Jy = I({
  initial: !1,
  schema: Wy,
  up(e) {
    return {
      ...e,
      v: 5
    };
  }
}), Ua = 5, Yy = i.object({
  v: i.number()
}), Er = jt({
  latestVersion: 5,
  versionMap: {
    1: qy,
    2: Gy,
    3: Ky,
    4: Qy,
    5: Jy
  },
  getVersion(e) {
    const t = Yy.safeParse(e);
    return t.success ? t.data.v : null;
  }
}), Xy = `
query Request {
  method
  url
  headers {
    key
    value
  }
}`.trim();
function em() {
  return {
    v: Ua,
    name: "Untitled",
    url: "https://echo.hoppscotch.io/graphql",
    headers: [],
    variables: `
{
  "id": "1"
}`.trim(),
    query: Xy,
    auth: {
      authType: "inherit",
      authActive: !0
    }
  };
}
function tm(e) {
  const t = Er.safeParse(e);
  return t.type === "ok" ? t.value : em();
}
function kg(e) {
  return {
    v: Ua,
    ...e
  };
}
const rm = i.object({
  v: i.literal(1),
  id: i.optional(i.string()),
  // For Firestore ID data
  name: i.string(),
  requests: i.array(
    i.lazy(
      () => i.union([
        ht(Pt),
        ht(Er)
      ])
    )
  )
}), qa = rm.extend({
  folders: i.lazy(() => i.array(qa))
}), On = I({
  initial: !0,
  schema: qa
}), nm = i.object({
  v: i.literal(2),
  id: i.optional(i.string()),
  // For Firestore ID data
  name: i.string(),
  requests: i.array(
    i.lazy(
      () => i.union([
        ht(Pt),
        ht(Er)
      ])
    )
  ),
  auth: i.union([Sr, Da]),
  headers: i.union([$r, i.array(wr)])
}), Ha = nm.extend({
  folders: i.lazy(() => i.array(Ha))
}), am = I({
  initial: !1,
  schema: Ha,
  up(e) {
    const t = {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "inherit"
      },
      headers: []
    };
    return e.id && (t.id = e.id), t;
  }
}), sm = i.object({
  v: i.number()
}), Cg = jt({
  latestVersion: 2,
  versionMap: {
    1: On,
    2: am
  },
  getVersion(e) {
    const t = sm.safeParse(e);
    return t.success ? t.data.v : On.schema.safeParse(e).success ? 1 : null;
  }
}), im = 2;
function Ba(e) {
  return {
    v: im,
    ...e
  };
}
function om(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(om), n = (e.requests ?? []).map(Dy), a = e.auth ?? { authType: "inherit", authActive: !0 }, s = e.headers ?? [], o = Ba({
    name: t,
    folders: r,
    requests: n,
    auth: a,
    headers: s
  });
  return e.id && (o.id = e.id), o;
}
function cm(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(cm), n = (e.requests ?? []).map(tm), a = e.auth ?? { authType: "inherit", authActive: !0 }, s = e.headers ?? [], o = Ba({
    name: t,
    folders: r,
    requests: n,
    auth: a,
    headers: s
  });
  return e.id && (o.id = e.id), o;
}
var te = function(e) {
  return function(t) {
    return !e(t);
  };
};
globalThis && globalThis.__spreadArray;
var um = Ps, lm = Is;
function Ga(e, t) {
  return t === void 0 ? function(r) {
    return Ga(e, r);
  } : lm(e, t) ? Ln : Vn(t[e]);
}
var za = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, dm = function(e) {
  return function(t) {
    for (var r = [], n = 0; n < t.length; n++) {
      var a = e(n, t[n]);
      Pn(a) && r.push(a.value);
    }
    return r;
  };
}, fm = function(e) {
  return dm(function(t, r) {
    return e(r);
  });
}, Ka = function(e) {
  return e.slice();
}, pm = Rs, jn = globalThis && globalThis.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, a = t.length, s; n < a; n++)
      (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}, hm = function(e) {
  return function(t) {
    return jn(jn([], t, !0), [e], !1);
  };
}, vm = hm, ym = function(e) {
  return [e];
}, mm = vm, gm = Ga, _m = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, bm = function() {
  return {
    concat: function(e, t) {
      return e.concat(t);
    }
  };
}, Tm = function() {
  return {
    concat: bm().concat,
    empty: []
  };
}, Dt = Ln, He = Vn;
function Fa(e) {
  return function(t) {
    return e(t) ? He(t) : Dt;
  };
}
var sr = function(e) {
  return function(t) {
    return Qa(t) ? Dt : He(e(t.value));
  };
}, $m = Pn, Qa = function(e) {
  return e._tag === "None";
}, Am = function(e, t) {
  return function(r) {
    return Qa(r) ? e() : t(r.value);
  };
}, Sm = Am, Or = Sm, wm = function(e, t) {
  for (var r = t(e); r._tag === "Left"; )
    r = t(r.left);
  return r.right;
}, re = Ts, B = $s, xm = /* @__PURE__ */ ys(2, function(e, t) {
  return ye(e) ? e : t(e.right);
}), Be = function(e) {
  return function(t) {
    return ye(t) ? t : B(e(t.right));
  };
}, Ut = function(e) {
  return function(t) {
    return ye(t) ? re(e(t.left)) : t;
  };
}, ye = _s, Em = bs, Om = function(e) {
  return function(t) {
    return ye(t) ? e(t.left) : t.right;
  };
}, jr = Om, kn = xm, yt = globalThis && globalThis.__assign || function() {
  return yt = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, yt.apply(this, arguments);
}, Ge = function(e, t, r) {
  return B({
    value: e,
    next: t,
    start: r
  });
}, ze = function(e, t, r) {
  return t === void 0 && (t = []), r === void 0 && (r = !1), re({
    input: e,
    expected: t,
    fatal: r
  });
}, jm = function(e, t) {
  return yt(yt({}, e), { expected: t });
}, km = function(e, t) {
  return Cm().concat(e, t);
}, Cm = function() {
  return {
    concat: function(e, t) {
      return e.input.cursor < t.input.cursor ? js().concat(e, t) : e.input.cursor > t.input.cursor ? Bt().concat(e, t) : Os({
        input: Bt(),
        fatal: Bt(),
        expected: Tm()
      }).concat(e, t);
    }
  };
}, Rm = function(e, t) {
  return t === void 0 && (t = 0), {
    buffer: e,
    cursor: t
  };
}, Im = function(e) {
  return gm(e.cursor, e.buffer);
}, Nm = function(e) {
  return e.cursor >= e.buffer.length;
}, Pm = function(e) {
  return m(Im(e), sr(function(t) {
    return { value: t, next: { buffer: e.buffer, cursor: e.cursor + 1 } };
  }));
}, ee = globalThis && globalThis.__assign || function() {
  return ee = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, ee.apply(this, arguments);
}, kr = function(e) {
  return function(t) {
    return Ge(e, t, t);
  };
}, Lm = function() {
  return function(e) {
    return ze(e);
  };
}, Vm = function(e) {
  return function() {
    return ze(e);
  };
}, j = function(e) {
  return m(Dm(Mm()), le(function(t) {
    var r = t[0], n = t[1];
    return e(r) ? me(r) : Vm(n);
  }));
}, O = function(e, t) {
  return function(r) {
    return m(e(r), Ut(function(n) {
      return jm(n, [t]);
    }));
  };
}, Mm = function() {
  return function(e) {
    return m(Pm(e), Or(function() {
      return ze(e);
    }, function(t) {
      var r = t.value, n = t.next;
      return Ge(r, n, e);
    }));
  };
}, Zm = function(e, t) {
  return function(r) {
    return m(e(r), kn(function(n) {
      return m(t(n.value)(n.next), kn(function(a) {
        return Ge(a.value, a.next, r);
      }));
    }));
  };
}, qt = function(e, t) {
  return function(r) {
    var n = e(r);
    return Em(n) || n.left.fatal ? n : m(t()(r), Ut(function(a) {
      return km(n.left, a);
    }));
  };
}, Dm = function(e) {
  return function(t) {
    return m(e(t), Be(function(r) {
      return ee(ee({}, r), { value: [r.value, t] });
    }));
  };
}, Wa = function(e) {
  return de(function() {
    return me(e.empty);
  });
}, Cr = function() {
  return O(function(e) {
    return Nm(e) ? Ge(void 0, e, e) : ze(e);
  }, "end of file");
}, Um = function(e) {
  return m(Rr(e), de(function() {
    return me([]);
  }));
}, Rr = function(e) {
  return m(e, le(function(t) {
    return Nr(ym(t), function(r) {
      return m(e, E(function(n) {
        return re(mm(n)(r));
      }), de(function() {
        return me(B(r));
      }));
    });
  }));
}, qm = function(e, t) {
  return function(r) {
    return m(e, le(function() {
      return r;
    }), Pr(function() {
      return t;
    }));
  };
}, Ja = function(e) {
  return qm(e, e);
}, Hm = function(e) {
  return Um(j(te(e)));
}, Ir = function(e, t) {
  return m(t, E(function() {
    return pm;
  }), de(function() {
    return Bm(e, t);
  }));
}, Bm = function(e, t) {
  return m(e, le(function(r) {
    return Nr(Ls(r), function(n) {
      return m(t, E(function() {
        return B(n);
      }), de(function() {
        return m(e, E(function(a) {
          return re(um(a)(n));
        }));
      }));
    });
  }));
}, Ke = function(e, t) {
  return function(r) {
    return m(e(r), Be(function(n) {
      return ee(ee({}, n), { value: t(n.value) });
    }));
  };
}, Ya = function(e, t) {
  return Ht(e, function(r) {
    return Ke(t, r);
  });
}, Ht = function(e, t) {
  return Zm(e, t);
}, Nr = function(e, t) {
  var r = function(n) {
    return function(a) {
      return ye(a.value) ? re({ value: a.value.left, stream: a.next }) : B(Ge(a.value.right, a.next, n));
    };
  };
  return function(n) {
    return wm({ value: e, stream: n }, function(a) {
      var s = t(a.value)(a.stream);
      return ye(s) ? B(ze(a.stream, s.left.expected, s.left.fatal)) : r(n)(s.right);
    });
  };
}, Gm = function(e, t) {
  return qt(e, t);
}, E = function(e) {
  return function(t) {
    return Ke(t, e);
  };
}, me = kr, le = function(e) {
  return function(t) {
    return Ht(t, e);
  };
}, Pr = function(e) {
  return function(t) {
    return Ht(t, function(r) {
      return Ke(e(r), function() {
        return r;
      });
    });
  };
}, de = function(e) {
  return function(t) {
    return Gm(t, e);
  };
}, zm = "Parser", Km = function(e) {
  return {
    concat: function(t, r) {
      return Ya(Ke(t, function(n) {
        return function(a) {
          return e.concat(n, a);
        };
      }), r);
    }
  };
}, Fm = function(e) {
  return ee(ee({}, Km(e)), { empty: kr(e.empty) });
}, Qm = {
  URI: zm,
  map: Ke,
  ap: Ya,
  chain: Ht,
  chainRec: Nr
}, Xa = function(e, t, r) {
  var n;
  return Object.assign({}, e, (n = {}, n[t] = r, n));
}, es = function(e) {
  return function(t) {
    return m(t, E(function(r) {
      return Xa({}, e, r);
    }));
  };
}, ir = function(e, t) {
  return function(r) {
    return m(r, le(function(n) {
      return m(t(n), E(function(a) {
        return Xa(n, e, a);
      }));
    }));
  };
}, Wm = function(e) {
  return ks(e)(e.empty);
};
Cs.concat;
var Jm = Wa(ur), ge = function(e) {
  return O(j(function(t) {
    return t === e;
  }), '"'.concat(e, '"'));
}, Ym = function(e) {
  return O(j(function(t) {
    return t !== e;
  }), 'anything but "'.concat(e, '"'));
}, Lr = function(e) {
  return Jm(Fe(e));
}, Fe = function(e) {
  return m(Rr(e), E(function(t) {
    return t.join("");
  }));
}, Vr = function(e) {
  return "0123456789".indexOf(e) !== -1;
}, or = O(j(Vr), "a digit"), Xm = /^\s$/, ts = function(e) {
  return Xm.test(e);
}, rs = O(j(ts), "a whitespace"), eg = function(e) {
  return e === "_";
}, Qe = function(e) {
  return /[a-z]/.test(e.toLowerCase());
}, ns = function(e) {
  return Qe(e) || Vr(e) || eg(e);
};
O(j(ns), "a word character");
O(j(Qe), "a letter");
var tg = function(e) {
  return e.toLowerCase() !== e.toUpperCase();
};
O(j(tg), "an unicode letter");
var as = function(e) {
  return Qe(e) && e === e.toUpperCase();
};
O(j(as), "an upper case letter");
var ss = function(e) {
  return Qe(e) && e === e.toLowerCase();
};
O(j(ss), "a lower case letter");
O(j(te(Vr)), "a non-digit");
var is = O(j(te(ts)), "a non-whitespace character");
O(j(te(ns)), "a non-word character");
O(j(te(Qe)), "a non-letter character");
O(j(te(as)), "anything but an upper case letter");
O(j(te(ss)), "anything but a lower case letter");
var os = function(e) {
  return O(Qm.chainRec(e, function(t) {
    return m(ag(0, t), Or(function() {
      return me(B(e));
    }, function(r) {
      return m(ge(r), le(function() {
        return me(re(t.slice(1)));
      }));
    }));
  }), JSON.stringify(e));
}, cr = Wm(Fm(ur)), De = Wa(ur), rg = function(e) {
  return De(ng(e));
}, ng = function(e) {
  return m(Rr(e), E(function(t) {
    return t.join("");
  }));
}, ag = function(e, t) {
  return e >= 0 && e < t.length ? He(t.charAt(e)) : Dt;
}, sg = Lr(rs);
Fe(rs);
Lr(is);
Fe(is);
var ig = function(e) {
  var t = +e;
  return isNaN(t) || e === "" ? Dt : He(t);
};
O(m(cr([De(ge("-")), Fe(or)]), E(function(e) {
  return +e;
})), "an integer");
O(m(cr([De(ge("-")), Lr(or), De(cr([ge("."), Fe(or)]))]), le(function(e) {
  return m(ig(e), Or(function() {
    return Lm();
  }, kr));
})), "a float");
var og = Ja(ge('"'))(rg(qt(os('\\"'), function() {
  return Ym('"');
})));
function cs(e) {
  return function(t) {
    return t(Rm(e.split("")));
  };
}
const Cn = (e, t) => (r) => ({
  ...r,
  [e]: t(r[e])
}), cg = ["#", ":"], _e = Ja(sg), Mr = (e) => (t) => t.join(e), Zr = (e) => m(
  Hm((t) => e.includes(t)),
  E(Mr(""))
), ug = W(
  Zr,
  Pr(() => j(() => !0))
), us = m(
  og,
  E((e) => JSON.parse(`"${e}"`))
), lg = m(
  _e(us),
  de(
    () => m(
      Zr([":", `
`]),
      E(Mn)
    )
  )
), dg = m(
  _e(us),
  de(
    () => m(
      Zr([`
`]),
      E(Mn)
    )
  )
), ls = m(
  De(os("#")),
  E(te(Zn))
), ds = m(
  _e(ls),
  es("commented"),
  ir("key", () => _e(lg)),
  Pr(() => ge(":")),
  ir("value", () => dg)
), fg = m(
  _e(ls),
  es("commented"),
  ir("key", () => qt(
    ug([`
`]),
    () => m(
      Ir(j((e) => !0), Cr()),
      E(W(
        Ka,
        Mr("")
      ))
    )
  )),
  E(W(
    Fa(({ key: e }) => !Zn(e))
  ))
), pg = m(
  Ir(_e(ds), Cr())
), hg = m(
  Ir(
    qt(
      m(ds, E(He)),
      () => m(
        fg,
        E(W(
          sr((e) => ({ ...e, value: "" }))
        ))
      )
    ),
    Cr()
  ),
  E(W(
    fm(W(
      Fa($m),
      sr((e) => e.value)
    ))
  ))
), vg = (e) => {
  if (cg.some((n) => e.includes(n)))
    return !0;
  const t = JSON.stringify(e);
  return t.substring(1, t.length - 1).trim() !== e;
}, Rn = (e) => vg(e) ? JSON.stringify(e) : e, Rg = (e) => m(
  e,
  _m(
    W(
      Cn("key", Rn),
      Cn("value", Rn),
      ({ key: t, value: r, active: n }) => n ? `${t}: ${r}` : `# ${t}: ${r}`
    )
  ),
  Mr(`
`)
), yg = (e) => m(
  hg,
  cs(e),
  Ut((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  Be(
    ({ value: t }) => m(
      t,
      za(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), Ig = (e) => m(
  pg,
  cs(e),
  Ut((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  Be(
    ({ value: t }) => m(
      t,
      za(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), Ng = W(
  yg,
  Be(Ka),
  jr(() => [])
), mg = i.object({
  id: i.optional(i.string()),
  name: i.string(),
  variables: i.array(
    i.object({
      key: i.string(),
      value: i.string()
    })
  )
}), In = I({
  initial: !0,
  schema: mg
}), fs = () => Math.random().toString(36).substring(2, 16), gg = i.object({
  v: i.literal(1),
  id: i.string(),
  name: i.string(),
  variables: i.array(
    i.union([
      i.object({
        key: i.string(),
        secret: i.literal(!0)
      }),
      i.object({
        key: i.string(),
        value: i.string(),
        secret: i.literal(!1).catch(!1)
      })
    ])
  )
}), _g = I({
  initial: !1,
  schema: gg,
  up(e) {
    return {
      ...e,
      v: 1,
      id: e.id || fs(),
      variables: e.variables.map((r) => ({
        ...r,
        secret: !1
      }))
    };
  }
}), bg = i.object({
  v: i.number()
}), Pg = jt({
  latestVersion: 1,
  versionMap: {
    0: In,
    1: _g
  },
  getVersion(e) {
    const t = bg.safeParse(e);
    return t.success ? t.data.v : In.schema.safeParse(e).success ? 0 : null;
  }
}), mt = /<<([^>]*)>>/g, gt = 10, ps = "ENV_EXPAND_LOOP", Nn = 1;
function Tg(e, t) {
  let r = e, n = 0;
  for (; r.match(mt) != null && n <= gt; )
    r = r.replace(mt, (a) => {
      const s = t.find(
        (o) => o.key === a.replace(/[<>]/g, "")
      );
      return s && "value" in s ? s.value : a;
    }), n++;
  return n > gt ? re(ps) : B(r);
}
const Lg = (e, t) => m(
  Tg(e, t),
  jr(() => e)
);
function $g(e, t, r = !1, n = !1) {
  if (!t || !e)
    return B(e);
  let a = e, s = 0, o = !1;
  for (; a.match(mt) != null && s <= gt && !o; )
    a = decodeURI(encodeURI(a)).replace(mt, (c, l) => {
      const u = t.find((h) => h && h.key === l);
      return u && "value" in u ? u.secret && n ? (o = !0, `<<${l}>>`) : u.secret && r ? "*".repeat(
        u.value.length
      ) : u.value : "";
    }), s++;
  return s > gt ? re(ps) : B(a);
}
const Vg = (e, t, r = !1, n = !1) => m(
  $g(e, t, r, n),
  jr(() => e)
), Ag = (e) => ({
  key: e.key,
  value: e.value,
  secret: !1
}), Mg = (e) => {
  if (e.v && e.v === Nn)
    return e;
  const t = e.id || fs(), r = e.name ?? "Untitled", n = (e.variables ?? []).map(Ag);
  return {
    v: Nn,
    id: t,
    name: r,
    variables: n
  };
};
export {
  Ry as AuthCodeGrantTypeParams,
  Ea as ClientCredentialsGrantTypeParams,
  im as CollectionSchemaVersion,
  Pg as Environment,
  Nn as EnvironmentSchemaVersion,
  br as FormDataKeyValue,
  wr as GQLHeader,
  Ua as GQL_REQ_SCHEMA_VERSION,
  Cg as HoppCollection,
  Da as HoppGQLAuth,
  Ma as HoppGQLAuthAPIKey,
  Vt as HoppGQLAuthBasic,
  Mt as HoppGQLAuthBearer,
  Zt as HoppGQLAuthInherit,
  Lt as HoppGQLAuthNone,
  Nt as HoppGQLAuthOAuth2,
  Er as HoppGQLRequest,
  Sr as HoppRESTAuth,
  Ca as HoppRESTAuthAPIKey,
  Ct as HoppRESTAuthBasic,
  Rt as HoppRESTAuthBearer,
  It as HoppRESTAuthInherit,
  kt as HoppRESTAuthNone,
  Nt as HoppRESTAuthOAuth2,
  $r as HoppRESTHeaders,
  Na as HoppRESTReqBody,
  Sg as HoppRESTReqBodyFormData,
  Pt as HoppRESTRequest,
  Sa as HoppRESTRequestVariables,
  ja as ImplicitOauthFlowParams,
  Oa as PasswordGrantTypeParams,
  Pa as RESTReqSchemaVersion,
  wg as ValidContentTypesList,
  em as getDefaultGQLRequest,
  Zy as getDefaultRESTRequest,
  xg as isEqualHoppRESTRequest,
  jg as isHoppRESTRequest,
  Ly as knownContentTypes,
  Ba as makeCollection,
  kg as makeGQLRequest,
  Og as makeRESTRequest,
  Lg as parseBodyEnvVariables,
  Tg as parseBodyEnvVariablesE,
  Ng as parseRawKeyValueEntries,
  yg as parseRawKeyValueEntriesE,
  Vg as parseTemplateString,
  $g as parseTemplateStringE,
  Rg as rawKeyValueEntriesToString,
  Eg as safelyExtractRESTRequest,
  Ig as strictParseRawKeyValueEntriesE,
  tm as translateToGQLRequest,
  Mg as translateToNewEnvironment,
  Ag as translateToNewEnvironmentVariables,
  cm as translateToNewGQLCollection,
  om as translateToNewRESTCollection,
  Dy as translateToNewRequest
};
